import React, { Component } from 'react';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import { Button } from 'telstra-ui/components/button/Button';
import Modal from 'telstra-ui/components/modal/Modal';
import 'telstra-ui/resources/telstraui.css';
import 'telstra-ui/resources/themes/pacific.css';
import renderHTML from 'react-render-html';
import AppWrapper from '../../app-wrapper';
import Loader from '../../components/loader';
import { stripStartingAndEndingPTags } from '../ssm-homepage/ssm-homepage.actions';
import SummaryDetails from '../ssm-homepage/ssm-components/summary-details/summary-details';
import ViewHeader from '../../components/view-header';
import AccountDetails from './amc-components/account_details/account_details';
import PlanDetails from './amc-components/plan-details/plan-details';
import OptimizePlanTableView from './amc-components/optimize-plan-table-view/optimize-plan-table-view';
import SubmitSection from './amc-components/submit-section/submit-section';
import { updateLiveChatValues, showHideOldNewHeaderFooter } from '../../app-actions';
import TotalTradeSection from './amc-components/total-trade-section/total-trade-section';
import DeviceLeasingSection from './amc-components/device-leasing-section/device-leasing-section';
import FloatingCta from '../../components/floating-cta';
import RequestCallBackModalOnline from './amc-components/request-callback-modal/request-callback-modal-online';
import RequestCallBackModalOffline from './amc-components/request-callback-modal/request-callback-modal-offline';

import {
  getCurrentPlanDetailsFromServiceDetails,
  getSuggestedPlanDetailsFromServiceDetails,
  preparePostCallForOptimizePlan,
  getOptimizePlanDetails,
  totalTradeValueCalculation,
  calculateMotif,
  calculateAverageAfsPerMonth,
  calculateMonthlyMoorupPerService,
  calculateTotalTradeInValue,
  calculateTotalSavingPerMonth,
  prepareSubmitAMCData,
  deviceOnAppleData,
  getFEOptimizeResult,
  convertOptimizedResultForFE,
  getCurrentDevicesListFromData,
  getCurrentPlanListFromData,
  calculateAddonCosts,
  validateNumber,
  validatePhoneNumberWithStartLetter,
  getAddonTypeCounts,
  getAddonPostcallForServiceNumber,
  getWirelessCurrentPlanList,
  getWirelessCurrentDevicesList,
  getUnaddressCurrentPlanList,
  getUnaddressCurrentDevicesList,
  getUnaddressTreatmentList,
} from './amc-homepage.actions';
import { NGM_NO_TEXT, IMAGE_BASE_LINK } from '../../app-constants';
import TradeInOffer from './amc-components/trade-in-offer/trade-in-offer';
import PlanDetailsTable from './amc-components/plan-details-table/plan-details-table';
import UnaddressableTable from './amc-components/unaddressable-table/unaddressable-table';
import WirelessTable from './amc-components/wireless-table/wireless-table';
import AddOnTable from './amc-components/add-on-table/add-on-table';
import './amc-homepage.css';

class AMCHomePageView extends Component {
  state = {
    modalIsOpen: false,
    formSubmittedLoader: false,
    reviewTermsAndConditions: false,
    customerSelectedOptions: {},
    performanceSelectedOptions: [],
    toggleRecommededPlan: false,
    currentPlanDetails: [],
    suggestedPlanDetails: [],
    totalFutureSpentPerMonth: 0,
    totalFutureDataInclusionPerMonth: 0,
    recommendedPlanType: '',
    searchUsed: NGM_NO_TEXT,
    disabledShowPlanBtn: true,
    showSection: true,
    serviceNumbersWithFlag: {},
    tradeInDevice: {},
    includeIphone: {},
    tradeDropDownValue: {},
    totalTradeValue: {
      totalTradeInValue: 0,
      totalFundContribution: 0,
    },
    serviceCheckboxVal: {},
    bulkModalOpen: false,
    bulkNewDeviceValue: 'NOSELECTION',
    bulkTradeInChecked: true,
    serviceCheckAll: false,
    currentPage: 0,
    contractTerm: 24,
    tradeInOfferSorting: {
      sortingField: 'number',
      numberSortType: 'ASC',
      userSortType: 'ASC',
      deviceSortType: 'ASC',
      valueSortType: 'ASC',
    },
    planSorting: {
      sortingField: 'number',
      numberSortType: 'ASC',
      userSortType: 'ASC',
      currentPlanNameSortType: 'ASC',
      currentPlanCostSortType: 'ASC',
      dataUsageSortType: 'ASC',
    },
    unaddressSorting: {
      sortingField: 'number',
      numberSortType: 'ASC',
      userSortType: 'ASC',
      currentPlanNameSortType: 'ASC',
      currentPlanCostSortType: 'ASC',
      dataUsageSortType: 'ASC',
      treatmentSortType: 'ASC',
      deviceSortType: 'ASC',
    },
    wirelessSorting: {
      sortingField: 'number',
      numberSortType: 'ASC',
      userSortType: 'ASC',
      currentPlanNameSortType: 'ASC',
      currentPlanCostSortType: 'ASC',
      dataUsageSortType: 'ASC',
      deviceSortType: 'ASC',
    },
    searchFieldSelectedOption: '',
    tradeInSearchText: '',
    resetBtnDisabled: true,
    feOptimizerInProgress: false,
    bulkTradePlanDropDownSelection: 'mobileEpic',
    currentTab: 'tab1',
    planDropDownOptions: {},
    serviceNumbersPlanDetails: [],
    planServiceCheckboxVal: {},
    planDetailsCurrentPage: 0,
    bulkPlanModalOpen: false,
    bulkPlanDeviceValue: '',
    planServiceCheckAll: false,
    searchPlanSelectedOption: '',
    unaddressCurrentPage: 0,
    searchUnaddressSelectedOption: '',
    unaddressSearchText: '',
    planSearchText: '',
    wirelessSearchText: '',
    searchWirelessSelectedOption: '',
    wirelessCurrentPage: 0,
    wirelessDropDownOptions: {},
    wirelessCheckboxVal: {},
    wirelessCheckboxStatus: false,
    wirelessCheckAll: false,
    bulkWirelessModalOpen: false,
    bulkWirelessDeviceValue: '',
    updatedSummaryTable: false,
    iDOPlanDropDownValue: {},
    dataTopUpDropDownValue: {},
    mobileEtcDropDownValue: {},
    addOnCheckboxVal: {},
    addOnCheckAll: false,
    voice2TextCheckboxVal: {},
    iPhoneMsgBankCheckboxVal: {},
    oneNumberCheckboxVal: {},
    monthPassCheckboxVal: {},
    acceleratorCheckboxVal: {},
    demandDataCheckboxVal: {},
    addOnCurrentPage: 0,
    optimizeBtnDisabled: true,
    searchAddOnSelectedOption: '',
    addOnDetailsCurrentPage: 0,
    addOnSearchText: '',
    callBackRequestLiveChatOfflineModalIsOpen: false,
    callBackRequestLiveChatOnlineModalIsOpen: false,
    callBackRequestCompleted: false,
    callBackPhoneNumber: '',
    IsCallBackPhoneNumberhasError: false,
    planModalOpen: false,
    addonWarningPopup: false,
    addonBulkModal: false,
    bulkAddonIDDValue: 'na',
    bulkAddonMobileValue: 'na',
    bulkAddonDataTopupValue: 'na',
    bulkAddonVoice2TextCheckbox: false,
    bulkAddonMsgBankCheckbox: false,
    bulkAddonOneNumberCheckbox: false,
    bulkAddonMonthPassCheckbox: false,
    bulkAddonAcceleratorCheckbox: false,
    bulkAddonDemandDataCheckbox: false,
    isAddonPlanTypeSame: false,
    isVoicePlan: false,
    isBrodbandPlan: false,
    isWirelessPlan: false,
    headerMobileETCValue: '',
  }
  componentDidMount = () => {
    showHideOldNewHeaderFooter(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataLoaded !== this.props.dataLoaded && this.props.dataLoaded && this.props.formSubmitted === false) {
      updateLiveChatValues(this.props.authorableContent.liveChat, 'AMC');
      const currentNumberDetails = getCurrentPlanDetailsFromServiceDetails(this.props.getData.serviceNumberDetails);
      const suggestedNumberDetails = getSuggestedPlanDetailsFromServiceDetails(this.props.getData.serviceNumberDetails,
        this.props.authorableContent.recommededPlans);
      const planDropDownOptions = this.props.authorableContent.tradeInOffer.formFields.planSearchFields.options;
      const serviceNumbersPlanDetailsNormal = this.props.getData.serviceNumberDetails
        .filter(item => item.suggestedPlanName !== 'unaddressableServices');
      const serviceNumbersPlanDetailsUnAddress = this.props.getData.serviceNumberDetails
        .filter(item => item.suggestedPlanName === 'unaddressableServices');
      const serviceNumbersPlanDetails = [...serviceNumbersPlanDetailsNormal, ...serviceNumbersPlanDetailsUnAddress];
      const serviceCheckboxVal = { ...suggestedNumberDetails.serviceNumbersWithFlag };
      const planServiceCheckboxVal = { ...suggestedNumberDetails.serviceNumbersWithFlag };
      const wirelessCheckboxVal = { ...suggestedNumberDetails.serviceNumbersWithFlag };
      const planDropDownValue = { ...suggestedNumberDetails.serviceNumbersWithFlag };
      const addOnCheckboxVal = { ...suggestedNumberDetails.serviceNumbersWithFlag };
      Object.keys(serviceCheckboxVal).forEach((key) => {
        serviceCheckboxVal[key] = false;
      });
      Object.keys(planServiceCheckboxVal).forEach((key) => {
        planServiceCheckboxVal[key] = false;
      });
      Object.keys(wirelessCheckboxVal).forEach((key) => {
        wirelessCheckboxVal[key] = false;
      });
      Object.keys(planDropDownValue).forEach((key) => {
        planDropDownValue[key] = planDropDownValue[key].planName;
      });
      Object.keys(addOnCheckboxVal).forEach((key) => {
        addOnCheckboxVal[key] = false;
      });
      const wirelessDropDownOptions = this.props.authorableContent.tradeInOffer.formFields.wirelessDropdownFields.options;
      this.updateStateData({
        suggestedPlanDetails: suggestedNumberDetails.suggestedPlan,
        serviceNumbersWithFlag: suggestedNumberDetails.serviceNumbersWithFlag,
        currentPlanDetails: currentNumberDetails,
        toggleRecommededPlan: true,
        totalFutureSpentPerMonth: parseFloat(this.props.getData.totalFutureSpentPerMonth),
        totalFutureDataInclusionPerMonth: this.props.getData.totalFutureDataInclusionPerMonth,
        serviceCheckboxVal,
        planDropDownOptions,
        serviceNumbersPlanDetails,
        planServiceCheckboxVal,
        wirelessDropDownOptions,
        wirelessCheckboxVal,
        planDropDownValue,
        addOnCheckboxVal,
      });
    }
    if (prevProps.optimizePlanData !== this.props.optimizePlanData && this.props.loadedOptimizeData && this.props.formSubmitted === false) {
      const optimizeDetails = getOptimizePlanDetails(this.props.optimizePlanData,
        this.state.suggestedPlanDetails,
        this.state.serviceNumbersWithFlag);

      const mobileWirelessVoiceCost = parseInt(this.props.authorableContent.recommededPlans.mobileEnterpriseWirelessStaff.voiceCost, 10);
      const mobileWirelessDataCost = parseInt(this.props.authorableContent.recommededPlans.mobileEnterpriseWirelessStaff.dataCost, 10);

      let mobileWirelessServicesCount = 0;
      const mobileWirelessPlan = this.state.suggestedPlanDetails.find(plan => plan.planName === 'mobileEnterpriseWireless');
      if (mobileWirelessPlan) {
        mobileWirelessServicesCount = mobileWirelessPlan.numbersOnPlan.length;
      }
      this.updateStateData({
        suggestedPlanDetails: optimizeDetails.suggestedPlan,
        serviceNumbersWithFlag: optimizeDetails.updatedServiceNumbersWithFlag,
        totalFutureSpentPerMonth: parseFloat(optimizeDetails.totalFutureSpentPerMonth) + (mobileWirelessVoiceCost * mobileWirelessServicesCount),
        totalFutureDataInclusionPerMonth: optimizeDetails.totalFutureDataInclusionPerMonth + (mobileWirelessDataCost * mobileWirelessServicesCount),
        iDOPlanDropDownValue: {},
        dataTopUpDropDownValue: {},
        mobileEtcDropDownValue: {},
        addOnCheckboxVal: {},
        addOnCheckAll: false,
        voice2TextCheckboxVal: {},
        iPhoneMsgBankCheckboxVal: {},
        oneNumberCheckboxVal: {},
        monthPassCheckboxVal: {},
        acceleratorCheckboxVal: {},
        demandDataCheckboxVal: {},
        currentTab: 'tab1',
      });
    }
    window.history.scrollRestoration = 'manual';
  }

  onOpenRequestCallBack = () => {
    const isLiveChatAgentPresent = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
    if (isLiveChatAgentPresent) {
      this.setState({ callBackRequestLiveChatOnlineModalIsOpen: true });
    } else {
      this.setState({ callBackRequestLiveChatOfflineModalIsOpen: true });
    }
  }

  onCloseRequestCallBackOffline = () => {
    this.setState({
      callBackRequestLiveChatOfflineModalIsOpen: false,
      callBackRequestLiveChatOnlineModalIsOpen: false,
      callBackRequestCompleted: false,
      IsCallBackPhoneNumberhasError: false,
      callBackPhoneNumber: '',
    });
  }

  onStartLiveChat = () => {
    this.setState({
      callBackRequestLiveChatOfflineModalIsOpen: false,
      callBackRequestLiveChatOnlineModalIsOpen: false,
      callBackRequestCompleted: false,
    });
    const liveChatButton = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
    liveChatButton.click();
  }

  onOnlineRequestCallBack = () => {
    this.setState({
      callBackRequestLiveChatOnlineModalIsOpen: false,
      callBackRequestLiveChatOfflineModalIsOpen: true,
    });
  }

  onRequestCallBackCompleted = () => {
    this.setState({ callBackRequestCompleted: true });
    this.onSubmitSiteSubmitButton(true);
  }

  onUpdatedSummaryTableValue = () => {
    if (this.state.updatedSummaryTable) {
      this.setState({ updatedSummaryTable: false });
    }
  };

  onPlanBulkModalClose = () => {
    this.setState({ bulkPlanModalOpen: false });
  };

  onPlanBulkModalOpen = () => {
    this.setState({
      bulkPlanModalOpen: true,
      bulkPlanDeviceValue: '',
      bulkTradeInChecked: true,
    });
  };

  onAddonBulkModalClose = () => {
    this.setState({
      addonBulkModal: false,
      isVoicePlan: false,
      isBrodbandPlan: false,
      isWirelessPlan: false,
      bulkAddonIDDValue: 'na',
      bulkAddonDataTopupValue: 'na',
      bulkAddonMobileValue: 'na',
      bulkAddonVoice2TextCheckbox: false,
      bulkAddonMsgBankCheckbox: false,
      bulkAddonOneNumberCheckbox: false,
      bulkAddonMonthPassCheckbox: false,
      bulkAddonAcceleratorCheckbox: false,
      bulkAddonDemandDataCheckbox: false,
    });
  };

  onAddonWarningPopupClose = () => {
    this.setState({ addonWarningPopup: false });
  };

  onAddonBulkAction = (selectedNumbers) => {
    const wireless = 'mobileEnterpriseWireless';
    const serviceFlag = this.state.serviceNumbersWithFlag;
    const checkboxSelected = this.state.addOnCheckboxVal;
    const serviceData = Object.keys(checkboxSelected).filter(key => (checkboxSelected[key]) && selectedNumbers.includes(key));
    const firstValue = serviceData[0];
    const selectedDataOnly = serviceFlag[firstValue].dataOnly;
    const selectedPlanName = serviceFlag[firstValue].planName;
    const isWirelessSelected = serviceData.some(numb => serviceFlag[numb].planName === wireless);

    const isSamePlanType = serviceData.some((plan) => {
      if (isWirelessSelected) {
        if (serviceFlag[plan].planName !== selectedPlanName) { return true; }
      } else if (serviceFlag[plan].dataOnly === selectedDataOnly) {
        return false;
      } else if (serviceFlag[plan].dataOnly !== selectedDataOnly) {
        return true;
      }
      return false;
    });

    if (!isSamePlanType) {
      if (selectedPlanName === wireless) {
        this.setState({ isWirelessPlan: true });
      } else if (selectedDataOnly) {
        this.setState({ isBrodbandPlan: true });
      } else {
        this.setState({ isVoicePlan: true });
      }
      this.setState({ addonBulkModal: true });
    } else {
      this.setState({ addonWarningPopup: true });
    }
  };

  onAddonBulkActionApply = (selectedNumbers) => {
    let newIDOPlanDropDownValue = this.state.iDOPlanDropDownValue;
    let newMobileEtcDropDownValue = this.state.mobileEtcDropDownValue;
    let newDataTopUpDropDownValue = this.state.dataTopUpDropDownValue;
    let newVoice2TextCheckboxVal = this.state.voice2TextCheckboxVal;
    let newIPhoneMsgBankCheckboxVal = this.state.iPhoneMsgBankCheckboxVal;
    let newOneNumberCheckboxVal = this.state.oneNumberCheckboxVal;
    let newMonthPassCheckboxVal = this.state.monthPassCheckboxVal;
    let newAcceleratorCheckboxVal = this.state.acceleratorCheckboxVal;
    let newDemandDataCheckboxVal = this.state.demandDataCheckboxVal;

    const bulkAddonIDDValue = this.state.bulkAddonIDDValue;
    const bulkAddonDataTopupValue = this.state.bulkAddonDataTopupValue;
    const bulkAddonMobileValue = this.state.bulkAddonMobileValue;
    const bulkAddonVoice2TextCheckbox = this.state.bulkAddonVoice2TextCheckbox;
    const bulkAddonMsgBankCheckbox = this.state.bulkAddonMsgBankCheckbox;
    const bulkAddonOneNumberCheckbox = this.state.bulkAddonOneNumberCheckbox;
    const bulkAddonMonthPassCheckbox = this.state.bulkAddonMonthPassCheckbox;
    const bulkAddonAcceleratorCheckbox = this.state.bulkAddonAcceleratorCheckbox;
    const bulkAddonDemandDataCheckbox = this.state.bulkAddonDemandDataCheckbox;

    selectedNumbers.forEach((numb) => {
      const isVoicePlan = this.state.isVoicePlan;
      const isBrodbandPlan = this.state.isBrodbandPlan;
      const isWirelessPlan = this.state.isWirelessPlan;

      if (isBrodbandPlan || isVoicePlan) {
        newMonthPassCheckboxVal = { ...newMonthPassCheckboxVal, [numb]: bulkAddonMonthPassCheckbox };
        newAcceleratorCheckboxVal = { ...newAcceleratorCheckboxVal, [numb]: bulkAddonAcceleratorCheckbox };
        newDemandDataCheckboxVal = { ...newDemandDataCheckboxVal, [numb]: bulkAddonDemandDataCheckbox };
      }
      if (isWirelessPlan || isVoicePlan) {
        newIDOPlanDropDownValue = { ...newIDOPlanDropDownValue, [numb]: bulkAddonIDDValue };
      }
      if (isVoicePlan) {
        newVoice2TextCheckboxVal = { ...newVoice2TextCheckboxVal, [numb]: bulkAddonVoice2TextCheckbox };
        newIPhoneMsgBankCheckboxVal = { ...newIPhoneMsgBankCheckboxVal, [numb]: bulkAddonMsgBankCheckbox };
        newOneNumberCheckboxVal = { ...newOneNumberCheckboxVal, [numb]: bulkAddonOneNumberCheckbox };
      }
      if (isWirelessPlan) {
        newDataTopUpDropDownValue = { ...newDataTopUpDropDownValue, [numb]: bulkAddonDataTopupValue };
      }
      newMobileEtcDropDownValue = { ...newMobileEtcDropDownValue, [numb]: bulkAddonMobileValue };
    });

    this.setState({
      iDOPlanDropDownValue: newIDOPlanDropDownValue,
      mobileEtcDropDownValue: newMobileEtcDropDownValue,
      dataTopUpDropDownValue: newDataTopUpDropDownValue,
      voice2TextCheckboxVal: newVoice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal: newIPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal: newOneNumberCheckboxVal,
      monthPassCheckboxVal: newMonthPassCheckboxVal,
      acceleratorCheckboxVal: newAcceleratorCheckboxVal,
      demandDataCheckboxVal: newDemandDataCheckboxVal,
      bulkAddonIDDValue: 'na',
      bulkAddonMobileValue: 'na',
      bulkAddonDataTopupValue: 'na',
      bulkAddonVoice2TextCheckbox: false,
      bulkAddonMsgBankCheckbox: false,
      bulkAddonOneNumberCheckbox: false,
      bulkAddonMonthPassCheckbox: false,
      bulkAddonAcceleratorCheckbox: false,
      bulkAddonDemandDataCheckbox: false,
      addonBulkModal: false,
      isVoicePlan: false,
      isBrodbandPlan: false,
      isWirelessPlan: false,
    });
  };

  onBulkWirelessActionsApply = (selectedNumbers) => {
    const selectedValue = this.state.bulkWirelessDeviceValue.length < 2 ? 'removePlan' : this.state.bulkWirelessDeviceValue;
    const bulkServiceNumbers = selectedNumbers;

    const suggestedPlanDetailsNew = this.state.suggestedPlanDetails;


    const {
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      wirelessCheckboxVal,
    } = this.state;

    bulkServiceNumbers.forEach((numb) => {
      const existingPlan = this.state.serviceNumbersWithFlag[numb].planName;
      suggestedPlanDetailsNew.forEach((planItem) => {
        if (planItem.planName === existingPlan) {
          planItem.numbersOnPlan = planItem.numbersOnPlan.filter(enumber => enumber !== numb); // eslint-disable-line
        } if (planItem.planName === selectedValue) {
          planItem.numbersOnPlan.push(numb);
        }
      });

      delete dataTopUpDropDownValue[numb];
      delete mobileEtcDropDownValue[numb];
      delete addOnCheckboxVal[numb];
      wirelessCheckboxVal[numb] = false;
    });

    const serviceNumbersPlanDetails = this.state.serviceNumbersPlanDetails.map((item) => {
      if (bulkServiceNumbers.includes(item.serviceNumber)) {
        return {
          ...item,
          suggestedPlanName: `${selectedValue}`,
        };
      }
      return item;
    });

    const { totalFutureDataInclusionPerMonth, totalFutureSpentPerMonth, serviceNumbersWithFlag } =
      this.getTotalCostAndDataWireless(selectedValue, bulkServiceNumbers);


    this.setState({
      serviceNumbersPlanDetails,
      bulkWirelessModalOpen: false,
      bulkWirelessDeviceValue: '',
      suggestedPlanDetails: suggestedPlanDetailsNew,
      totalFutureDataInclusionPerMonth,
      totalFutureSpentPerMonth,
      serviceNumbersWithFlag,
      optimizeBtnDisabled: false,
      resetBtnDisabled: false,
      currentPage: 0,
      planDetailsCurrentPage: 0,
      unaddressCurrentPage: 0,
      addOnDetailsCurrentPage: 0,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
    });
  }

  onBulkPlanActionsApply = (selectedNumbers) => {
    const selectedValue = this.state.bulkPlanDeviceValue;
    const bulkServiceNumbers = selectedNumbers;

    const suggestedPlanDetailsNew = this.state.suggestedPlanDetails;
    let newPlanDropDownValue = this.state.planDropDownValue;

    const {
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
      planServiceCheckboxVal,
    } = this.state;

    bulkServiceNumbers.forEach((numb) => {
      newPlanDropDownValue = { ...newPlanDropDownValue, [numb]: selectedValue };
      const existingPlan = this.state.serviceNumbersWithFlag[numb].planName;
      suggestedPlanDetailsNew.forEach((planItem) => {
        if (planItem.planName === existingPlan) {
          planItem.numbersOnPlan = planItem.numbersOnPlan.filter(enumber => enumber !== numb); // eslint-disable-line
        } if (planItem.planName === selectedValue) {
          planItem.numbersOnPlan.push(numb);
        }

        delete iDOPlanDropDownValue[numb];
        delete dataTopUpDropDownValue[numb];
        delete mobileEtcDropDownValue[numb];
        delete addOnCheckboxVal[numb];
        delete voice2TextCheckboxVal[numb];
        delete iPhoneMsgBankCheckboxVal[numb];
        delete oneNumberCheckboxVal[numb];
        delete monthPassCheckboxVal[numb];
        delete acceleratorCheckboxVal[numb];
        delete demandDataCheckboxVal[numb];
        planServiceCheckboxVal[numb] = false;
      });
    });


    const serviceNumbersPlanDetails = this.state.serviceNumbersPlanDetails.map((item) => {
      if (bulkServiceNumbers.includes(item.serviceNumber)) {
        return {
          ...item,
          suggestedPlanName: `${selectedValue}`,
        };
      }
      return item;
    });

    const { totalFutureDataInclusionPerMonth, totalFutureSpentPerMonth, serviceNumbersWithFlag } =
      this.getTotalCostAndData(selectedValue, bulkServiceNumbers);

    this.setState({
      serviceNumbersPlanDetails,
      bulkPlanModalOpen: false,
      bulkPlanDeviceValue: '',
      totalFutureDataInclusionPerMonth,
      totalFutureSpentPerMonth,
      serviceNumbersWithFlag,
      suggestedPlanDetails: suggestedPlanDetailsNew,
      planDropDownValue: newPlanDropDownValue,
      resetBtnDisabled: false,
      optimizeBtnDisabled: false,
      currentPage: 0,
      unaddressCurrentPage: 0,
      wirelessCurrentPage: 0,
      addOnDetailsCurrentPage: 0,
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
    });
  }

  onWirelessBulkModalClose = () => {
    this.setState({ bulkWirelessModalOpen: false });
  };

  onWirelessBulkModalOpen = () => {
    this.setState({ bulkWirelessModalOpen: true });
  };

  onBulkModalClose = () => {
    this.setState({ bulkModalOpen: false });
  };

  onBulkModalOpen = () => {
    this.setState({
      bulkModalOpen: true,
      bulkNewDeviceValue: 'NOSELECTION',
      bulkTradeInChecked: true,
      bulkTradePlanDropDownSelection: 'mobileEpic',
    });
  };

  onBulkPlanChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ bulkPlanDeviceValue: selectedValue });
  };

  onBulkWirelessChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ bulkWirelessDeviceValue: selectedValue });
  }

  onBulkActionsApply = (selectedNumbers) => {
    const bulkServiceNumbers = selectedNumbers;

    const recommededPlans = this.props.authorableContent.recommededPlans;

    const planArr = recommededPlans.voicePlanNames.split(',').map(paln => paln.split('|')[0]);
    const filterServiceNumberArr = this.props.getData.serviceNumberDetails.filter(numbers =>
      selectedNumbers.includes(numbers.serviceNumber) && planArr.includes(this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName));

    let newTradeDropDownValue = this.state.tradeDropDownValue;
    let newTradeInDevice = this.state.tradeInDevice;

    let totalFutureDataInclusionPerMonth = this.state.totalFutureDataInclusionPerMonth;
    let totalFutureSpentPerMonth = this.state.totalFutureSpentPerMonth;

    const serviceNumbersWithFlag = this.state.serviceNumbersWithFlag;
    const suggestedPlanDetailsNew = this.state.suggestedPlanDetails;

    const {
      iDOPlanDropDownValue,
      dataTopUpDropDownValue, 
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
      serviceCheckboxVal,
    } = this.state;

    const { bulkNewDeviceValue, bulkTradePlanDropDownSelection } = this.state;
    if (bulkNewDeviceValue !== 'NOSELECTION' && bulkTradePlanDropDownSelection !== 'NOPLANSELECTION') {
      bulkServiceNumbers.forEach((numb) => {
        newTradeDropDownValue = { ...newTradeDropDownValue, [numb]: this.state.bulkNewDeviceValue };
        if (serviceNumbersWithFlag[numb].planName !== 'removePlan') {
          const existingPlan = serviceNumbersWithFlag[numb].planName;
          const newPlanName = `${bulkTradePlanDropDownSelection}Staff`;

          const existingPlanDetails = recommededPlans[`${existingPlan}Staff`];
          const newPlanDetails = recommededPlans[newPlanName];

          const voiceCostDiff = parseFloat(newPlanDetails.voiceCost) - parseFloat(existingPlanDetails.voiceCost);
          const dataCostDiff = parseFloat(newPlanDetails.dataCost) - parseFloat(existingPlanDetails.dataCost);

          totalFutureDataInclusionPerMonth += dataCostDiff;
          totalFutureSpentPerMonth += voiceCostDiff;

          serviceNumbersWithFlag[numb].planName = bulkTradePlanDropDownSelection;

          delete iDOPlanDropDownValue[numb];
          delete dataTopUpDropDownValue[numb];
          delete addOnCheckboxVal[numb];
          delete voice2TextCheckboxVal[numb];
          delete iPhoneMsgBankCheckboxVal[numb];
          delete oneNumberCheckboxVal[numb];
          delete monthPassCheckboxVal[numb];
          delete acceleratorCheckboxVal[numb];
          delete demandDataCheckboxVal[numb];
          serviceCheckboxVal[numb] = false;

          if (existingPlan !== bulkTradePlanDropDownSelection) {
            suggestedPlanDetailsNew.forEach((planItem) => {
              if (planItem.planName === existingPlan) {
                planItem.numbersOnPlan = planItem.numbersOnPlan.filter(enumber => enumber !== numb); // eslint-disable-line
              } else if (planItem.planName === bulkTradePlanDropDownSelection) {
                planItem.numbersOnPlan.push(numb);
              }
            });
          }
        }
        if (this.state.bulkTradeInChecked) {
          const tradeValue = filterServiceNumberArr.find(serviceItem => serviceItem.serviceNumber === numb).tradeInValue;
          if (parseInt(tradeValue, 10) > 0) {
            newTradeInDevice = { ...newTradeInDevice, [numb]: true };
          }
        } else {
          const tradeValue = filterServiceNumberArr.find(serviceItem => serviceItem.serviceNumber === numb).tradeInValue;
          if (parseInt(tradeValue, 10) > 0) {
            newTradeInDevice = { ...newTradeInDevice, [numb]: false };
          }
        }
      });
    } else if (bulkNewDeviceValue !== 'NOSELECTION' && bulkTradePlanDropDownSelection === 'NOPLANSELECTION') {
      bulkServiceNumbers.forEach((numb) => {
        newTradeDropDownValue = { ...newTradeDropDownValue, [numb]: this.state.bulkNewDeviceValue };
        if (this.state.bulkTradeInChecked) {
          const tradeValue = filterServiceNumberArr.find(serviceItem => serviceItem.serviceNumber === numb).tradeInValue;
          if (parseInt(tradeValue, 10) > 0) {
            newTradeInDevice = { ...newTradeInDevice, [numb]: true };
          }
        } else {
          const tradeValue = filterServiceNumberArr.find(serviceItem => serviceItem.serviceNumber === numb).tradeInValue;
          if (parseInt(tradeValue, 10) > 0) {
            newTradeInDevice = { ...newTradeInDevice, [numb]: false };
          }
        }
      });
    } else if (bulkNewDeviceValue === 'NOSELECTION' && bulkTradePlanDropDownSelection !== 'NOPLANSELECTION') {
      bulkServiceNumbers.forEach((numb) => {
        if (serviceNumbersWithFlag[numb].planName !== 'removePlan') {
          const existingPlan = serviceNumbersWithFlag[numb].planName;
          const newPlanName = `${bulkTradePlanDropDownSelection}Staff`;

          const existingPlanDetails = recommededPlans[`${existingPlan}Staff`];
          const newPlanDetails = recommededPlans[newPlanName];

          const voiceCostDiff = parseFloat(newPlanDetails.voiceCost) - parseFloat(existingPlanDetails.voiceCost);
          const dataCostDiff = parseFloat(newPlanDetails.dataCost) - parseFloat(existingPlanDetails.dataCost);

          totalFutureDataInclusionPerMonth += dataCostDiff;
          totalFutureSpentPerMonth += voiceCostDiff;

          serviceNumbersWithFlag[numb].planName = bulkTradePlanDropDownSelection;

          delete iDOPlanDropDownValue[numb];
          delete dataTopUpDropDownValue[numb];
          delete addOnCheckboxVal[numb];
          delete voice2TextCheckboxVal[numb];
          delete iPhoneMsgBankCheckboxVal[numb];
          delete oneNumberCheckboxVal[numb];
          delete monthPassCheckboxVal[numb];
          delete acceleratorCheckboxVal[numb];
          delete demandDataCheckboxVal[numb];

          if (existingPlan !== bulkTradePlanDropDownSelection) {
            suggestedPlanDetailsNew.forEach((planItem) => {
              if (planItem.planName === existingPlan) {
                planItem.numbersOnPlan = planItem.numbersOnPlan.filter(enumber => enumber !== numb); // eslint-disable-line
              } else if (planItem.planName === bulkTradePlanDropDownSelection) {
                planItem.numbersOnPlan.push(numb);
              }
            });
          }
        }
      });
    }

    this.setState({
      bulkModalOpen: false,
      tradeDropDownValue: newTradeDropDownValue,
      serviceNumbersWithFlag,
      tradeInDevice: newTradeInDevice,
      totalFutureDataInclusionPerMonth,
      totalFutureSpentPerMonth,
      suggestedPlanDetails: suggestedPlanDetailsNew,
      bulkNewDeviceValue: 'NOSELECTION',
      bulkTradePlanDropDownSelection: 'mobileEpic',
      bulkTradeInChecked: true,
      resetBtnDisabled: false,
      planDetailsCurrentPage: 0,
      unaddressCurrentPage: 0,
      wirelessCurrentPage: 0,
      addOnDetailsCurrentPage: 0,
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
    });
  };
  onBulkTradeInCheckBox = (event) => {
    this.setState({ bulkTradeInChecked: event.target.checked });
  };

  onBulkChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ bulkNewDeviceValue: selectedValue });
  };

  onBulkTradePlanChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ bulkTradePlanDropDownSelection: selectedValue });
  };

  onAddonBulkIDDChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ bulkAddonIDDValue: selectedValue });
  };

  onAddonBulkDataTopupChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ bulkAddonDataTopupValue: selectedValue });
  };

  onAddonBulkMobileChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ bulkAddonMobileValue: selectedValue });
  };

  onAddonBulkCheckBox = (event) => {
    const bulk = 'bulk';
    if (event.target.id === `${bulk}-voice2Text`) {
      this.setState({ bulkAddonVoice2TextCheckbox: event.target.checked });
    } else if (event.target.id === `${bulk}-iPhoneMessageBank`) {
      this.setState({ bulkAddonMsgBankCheckbox: event.target.checked });
    } else if (event.target.id === `${bulk}-oneNumber`) {
      this.setState({ bulkAddonOneNumberCheckbox: event.target.checked });
    } else if (event.target.id === `${bulk}-monthPass`) {
      this.setState({ bulkAddonMonthPassCheckbox: event.target.checked });
    } else if (event.target.id === `${bulk}-accelerator`) {
      this.setState({ bulkAddonAcceleratorCheckbox: event.target.checked });
    } else if (event.target.id === `${bulk}-demandData`) {
      this.setState({ bulkAddonDemandDataCheckbox: event.target.checked });
    }
  };

  onPageChangeHandler = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  }

  onPlanDetailsPageChangeHandler = (pageNumber) => {
    this.setState({ planDetailsCurrentPage: pageNumber });
  }

  onAddOnDetailsPageChangeHandler = (pageNumber) => {
    this.setState({ addOnDetailsCurrentPage: pageNumber });
  }

  onUnaddressPageChangeHandler = (pageNumber) => {
    this.setState({ unaddressCurrentPage: pageNumber });
  }

  onWirelessPageChangeHandler = (pageNumber) => {
    this.setState({ wirelessCurrentPage: pageNumber });
  }

  onSubmitSiteSubmitButton = (requestToCallBack, proposal) => {
    this.setState({ formSubmittedLoader: true });
    const { submitAMCCustomerData, downloadCustomerProposal } = this.props.actions;

    const { tradeInOffer, recommededPlans } = this.props.authorableContent;

    const { tradeDropDownValue, contractTerm, tradeInDevice, serviceNumbersWithFlag, suggestedPlanDetails } = this.state;

    const motifValue = calculateMotif(tradeInOffer.formFields, suggestedPlanDetails);

    const averageAfsValue = calculateAverageAfsPerMonth(tradeInOffer.formFields.afsCost,
      tradeDropDownValue, contractTerm);

    const moorUpPerServiceValue = calculateMonthlyMoorupPerService(tradeInDevice,
      this.props.getData.serviceNumberDetails, tradeDropDownValue, contractTerm);

    const avgPhoneCost = (averageAfsValue - motifValue - moorUpPerServiceValue) > 0 ?
      (averageAfsValue - motifValue - moorUpPerServiceValue) : 0;

    const rrpCost = calculateTotalSavingPerMonth(tradeInOffer.formFields.phoneCost,
      tradeDropDownValue, contractTerm);

    const savingCost = calculateTotalSavingPerMonth(tradeInOffer.formFields.phoneCost,
      tradeDropDownValue, contractTerm) - avgPhoneCost;

    const newDeviceCount = Object.values(tradeDropDownValue).filter(val => val !== 'NOSELECTION').length;

    const avgPhoneCost24 = avgPhoneCost * contractTerm * newDeviceCount;

    const tradeInDeviceCount = Object.values(tradeInDevice).filter(val => val !== false).length;

    const priceValidUntil = this.props.authorableContent.tradeInOffer.priceValidUntil;

    const mobileDevicesNumbers = suggestedPlanDetails.filter(plan => plan.dataOnly === false)
      .map(plan => plan.numbersOnPlan).reduce((a, b) => a.concat(b), []);
    const dataDevicesNumbers = suggestedPlanDetails.filter(plan => plan.dataOnly === true)
      .map(plan => plan.numbersOnPlan).reduce((a, b) => a.concat(b), []);

    let wirelessCount = 0;
    const wirelessPlan = suggestedPlanDetails.length > 0 &&
      suggestedPlanDetails.find(plan => plan.planName === 'mobileEnterpriseWireless');
    if (wirelessPlan) {
      wirelessCount = wirelessPlan.numbersOnPlan.length;
    }

    let removePlanCount = 0;
    const removePlanObj = suggestedPlanDetails.length > 0 &&
      suggestedPlanDetails.find(plan => plan.planName === 'removePlan');
    if (removePlanObj) {
      removePlanCount = removePlanObj.numbersOnPlan.length;
    }

    let unaddressablePlanCount = 0;
    const unaddressablePlanObj = suggestedPlanDetails.length > 0 &&
      suggestedPlanDetails.find(plan => plan.planName === 'unaddressableServices');
    if (unaddressablePlanObj) {
      unaddressablePlanCount = unaddressablePlanObj.numbersOnPlan.length;
    }

    const addonCosts = calculateAddonCosts(
      this.state.iDOPlanDropDownValue,
      this.state.voice2TextCheckboxVal,
      this.state.iPhoneMsgBankCheckboxVal,
      this.state.oneNumberCheckboxVal,
      this.state.monthPassCheckboxVal,
      this.state.acceleratorCheckboxVal,
      this.state.dataTopUpDropDownValue,
      this.state.demandDataCheckboxVal,
      tradeInOffer,
      this.state.serviceNumbersWithFlag,
    );

    const totalAMPlanDevices = mobileDevicesNumbers.length + dataDevicesNumbers.length + wirelessCount;

    const { getData } = this.props;
    const baseData = {
      totalCurrentDataInclusionPerMonth: getData.totalCurrentDataInclusionPerMonth,
      totalCurrentSpentPerMonth: getData.totalCurrentSpentPerMonth,
      totalFutureDataInclusionPerMonth: this.state.totalFutureDataInclusionPerMonth,
      totalFutureSpentPerMonth: this.state.totalFutureSpentPerMonth,
      noOfServicesOnSubmission: totalAMPlanDevices,
      noOfServicesOfRecommendToCancelOnSubmission: removePlanCount,
      noOfUnAddressableOnSubmission: unaddressablePlanCount,
      noOfNewDevicesSelected: newDeviceCount,
      noOfDevicesTradedIn: tradeInDeviceCount,
      totalAddOnCost: addonCosts,
      noOfAddOnsSelected: getAddonTypeCounts(this.state),
      requestToCallBack,
      contactNumber: requestToCallBack === true ? this.state.callBackPhoneNumber : '',
    };

    const serviceNumbersData = getData.serviceNumberDetails.filter(itm => itm.suggestedPlanName !== 'unaddressableServices').map((serviceItem) => { // eslint-disable-line
      const recommendedPlanName = serviceNumbersWithFlag[serviceItem.serviceNumber].planName === 'removePlan' ?
        'Remove' : serviceNumbersWithFlag[serviceItem.serviceNumber].planName;
      const recommendedPlanCost = serviceNumbersWithFlag[serviceItem.serviceNumber].planName === 'removePlan' ?
        0 : recommededPlans[`${serviceNumbersWithFlag[serviceItem.serviceNumber].planName}Staff`].voiceCost;
      const recommendedPlanData = serviceNumbersWithFlag[serviceItem.serviceNumber].planName === 'removePlan' ?
        0 : recommededPlans[`${serviceNumbersWithFlag[serviceItem.serviceNumber].planName}Staff`].dataCost;

      return {
        serviceNumber: serviceItem.serviceNumber,
        dataOnly: serviceNumbersWithFlag[serviceItem.serviceNumber].dataOnly,
        currentPlan: serviceItem.currentPlan,
        userName: serviceItem.userName,
        addOns: getAddonPostcallForServiceNumber(serviceItem.serviceNumber, this.state),
        recommendedPlanName,
        recommendedPlanCost: parseInt(recommendedPlanCost, 10),
        recommendedPlanData: parseInt(recommendedPlanData, 10),
        servicesOnIphoneEpic: serviceItem.dataOnly === false &&
          tradeDropDownValue[serviceItem.serviceNumber] !== undefined &&
          tradeDropDownValue[serviceItem.serviceNumber] !== 'NOSELECTION',
        newPhone: tradeDropDownValue[serviceItem.serviceNumber] !== undefined &&
          tradeDropDownValue[serviceItem.serviceNumber] !== 'NOSELECTION' ?
          tradeInOffer.formFields.tradeIphoneDropDown.options.find(opt => opt.key === tradeDropDownValue[serviceItem.serviceNumber]).value : '',
      };
    });

    const currentTotalCost = ((this.props.getData.totalCurrentSpentPerMonth * contractTerm)
      + (rrpCost * contractTerm * newDeviceCount));

    const proposedTotalCost = ((this.state.totalFutureSpentPerMonth * contractTerm)
      + (avgPhoneCost * contractTerm * newDeviceCount));

    const reductionCost = currentTotalCost - proposedTotalCost;

    const calculationsData = {
      contractTerm,
      priceValidUntil,
      devicesOnEpic: newDeviceCount,
      tradeInDeviceCount,
      avgAFSLease: parseFloat(averageAfsValue.toFixed(2)),
      avgAFSLeaseFor24months: parseFloat((averageAfsValue * contractTerm * newDeviceCount).toFixed(2)),
      avgTradeIn: -parseFloat(moorUpPerServiceValue.toFixed(2)),
      avgTradeInFor24months: -parseFloat((moorUpPerServiceValue * contractTerm * newDeviceCount).toFixed(2)),
      avgMotif: -parseFloat(motifValue.toFixed(2)),
      avgMotifFor24months: -parseFloat((motifValue * contractTerm * totalAMPlanDevices).toFixed(2)),
      avgIphone: parseFloat(avgPhoneCost.toFixed(2)),
      avgIphoneFor24months: parseFloat(avgPhoneCost24.toFixed(2)),
      avgIphoneRRPCost: parseFloat(rrpCost.toFixed(2)),
      avgIphoneRRPCostFor24months: parseFloat((rrpCost * contractTerm * newDeviceCount).toFixed(2)),
      savings: parseFloat(savingCost.toFixed(2)),
      savingsFor24months: parseFloat((savingCost * contractTerm * newDeviceCount).toFixed(2)),
      minimumCost: parseFloat(currentTotalCost.toFixed(2)),
      minimumCostFor24months: parseFloat(proposedTotalCost.toFixed(2)),
      reductionCost: parseFloat(((rrpCost + this.props.getData.totalCurrentSpentPerMonth)
        - (avgPhoneCost + this.state.totalFutureSpentPerMonth)).toFixed(2)),
      reductionCostFor24months: parseFloat(reductionCost.toFixed(2)),
      devicesOnApple: deviceOnAppleData(tradeInOffer, this.state.tradeDropDownValue),
    };

    const submitData = prepareSubmitAMCData(baseData, serviceNumbersData, calculationsData);

    if (proposal) {
      downloadCustomerProposal(submitData);
    } else {
      submitAMCCustomerData(submitData);
    }
  };

  onSubmitSiteConfirmButton = () => {
    this.setState({ modalIsOpen: true });
  };

  onChangeContractValue = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    this.setState({ contractTerm: parseInt(selectedValue, 10) });
  };

  onTradeSortingClick = (sortingField, sortType) => {
    const tradeInSorting = this.state.tradeInOfferSorting;
    tradeInSorting.sortingField = sortingField;
    tradeInSorting.numberSortType = sortingField === 'number' ? sortType : tradeInSorting.numberSortType;
    tradeInSorting.userSortType = sortingField === 'userName' ? sortType : tradeInSorting.userSortType;
    tradeInSorting.deviceSortType = sortingField === 'deviceType' ? sortType : tradeInSorting.deviceSortType;
    tradeInSorting.valueSortType = sortingField === 'tradeInValue' ? sortType : tradeInSorting.valueSortType;

    this.setState({ tradeInOfferSorting: tradeInSorting });
  }

  onPlanSortingClick = (sortingField, sortType) => {
    const planSortings = this.state.planSorting;
    planSortings.sortingField = sortingField;
    planSortings.numberSortType = sortingField === 'number' ? sortType : planSortings.numberSortType;
    planSortings.userSortType = sortingField === 'userName' ? sortType : planSortings.userSortType;
    planSortings.currentPlanNameSortType = sortingField === 'currentPlanName' ? sortType : planSortings.currentPlanNameSortType;
    planSortings.currentPlanCostSortType = sortingField === 'currentPlanCost' ? sortType : planSortings.currentPlanCostSortType;
    planSortings.dataUsageSortType = sortingField === 'dataUsage' ? sortType : planSortings.dataUsageSortType;

    this.setState({ planSorting: planSortings });
  }

  onUnaddressSortingClick = (sortingField, sortType) => {
    const unaddressSortings = this.state.unaddressSorting;
    unaddressSortings.sortingField = sortingField;
    unaddressSortings.numberSortType = sortingField === 'number' ? sortType : unaddressSortings.numberSortType;
    unaddressSortings.userSortType = sortingField === 'userName' ? sortType : unaddressSortings.userSortType;
    unaddressSortings.currentPlanNameSortType = sortingField === 'currentPlanName' ? sortType : unaddressSortings.currentPlanNameSortType;
    unaddressSortings.currentPlanCostSortType = sortingField === 'currentPlanCost' ? sortType : unaddressSortings.currentPlanCostSortType;
    unaddressSortings.dataUsageSortType = sortingField === 'dataUsage' ? sortType : unaddressSortings.dataUsageSortType;
    unaddressSortings.treatmentSortType = sortingField === 'treatment' ? sortType : unaddressSortings.treatmentSortType;
    unaddressSortings.deviceSortType = sortingField === 'deviceType' ? sortType : unaddressSortings.deviceSortType;

    this.setState({ unaddressSorting: unaddressSortings });
  }

  onWirelessSortingClick = (sortingField, sortType) => {
    const wirelessSortings = this.state.wirelessSorting;
    wirelessSortings.sortingField = sortingField;
    wirelessSortings.numberSortType = sortingField === 'number' ? sortType : wirelessSortings.numberSortType;
    wirelessSortings.userSortType = sortingField === 'userName' ? sortType : wirelessSortings.userSortType;
    wirelessSortings.currentPlanNameSortType = sortingField === 'currentPlanName' ? sortType : wirelessSortings.currentPlanNameSortType;
    wirelessSortings.currentPlanCostSortType = sortingField === 'currentPlanCost' ? sortType : wirelessSortings.currentPlanCostSortType;
    wirelessSortings.dataUsageSortType = sortingField === 'dataUsage' ? sortType : wirelessSortings.dataUsageSortType;
    wirelessSortings.deviceSortType = sortingField === 'deviceType' ? sortType : wirelessSortings.deviceSortType;

    this.setState({ wirelessSorting: wirelessSortings });
  }

  onCloseDialogBox = () => {
    this.setState({
      modalIsOpen: false,
    });
  }

  onChangedSubmitCheckBox = (event) => {
    this.setState({ reviewTermsAndConditions: event.target.checked });
  };

  onChangeCheckBox = (event) => {
    const [number, type] = event.target.id.split('-');
    const checkedValue = event.target.checked;
    if (type === 'iPhone') {
      const includeIphone = { ...this.state.includeIphone, [number]: checkedValue };
      this.setState({ includeIphone });
    } else if (type === 'service') {
      const serviceCheckboxVal = { ...this.state.serviceCheckboxVal, [number]: checkedValue };
      delete serviceCheckboxVal.all;
      if (number === 'all') {
        Object.keys(serviceCheckboxVal).forEach((key) => {
          if (this.state.serviceNumbersWithFlag[key].planName !== 'removePlan'
            && this.state.serviceNumbersWithFlag[key].planName !== 'unaddressableServices'
            && this.state.serviceNumbersWithFlag[key].dataOnly === false) {
            serviceCheckboxVal[key] = checkedValue;
          }
        });
        this.setState({ serviceCheckboxVal, serviceCheckAll: checkedValue });
      } else {
        serviceCheckboxVal[number] = checkedValue;
        this.setState({ serviceCheckboxVal });
      }
    } else if (type === 'planService') {
      const planServiceCheckboxVal = { ...this.state.planServiceCheckboxVal, [number]: checkedValue };
      if (number === 'all') {
        Object.keys(planServiceCheckboxVal).forEach((key) => {
          planServiceCheckboxVal[key] = checkedValue;
        });
        this.setState({ planServiceCheckboxVal, planServiceCheckAll: checkedValue });
      } else {
        planServiceCheckboxVal[number] = checkedValue;
        this.setState({ planServiceCheckboxVal });
      }
    } else if (type === 'wirelessService') {
      const wirelessCheckboxVal = { ...this.state.wirelessCheckboxVal, [number]: checkedValue };
      if (number === 'all') {
        Object.keys(wirelessCheckboxVal).forEach((key) => {
          wirelessCheckboxVal[key] = checkedValue;
        });
        this.setState({ wirelessCheckboxVal, wirelessCheckAll: checkedValue });
      } else {
        wirelessCheckboxVal[number] = checkedValue;

        let wirelessCheckboxStatus;

        Object.keys(wirelessCheckboxVal).forEach((key) => {
          if (wirelessCheckboxVal[key] === true) {
            wirelessCheckboxStatus = true;
          }
        });

        this.setState({ wirelessCheckboxVal, wirelessCheckboxStatus });
      }
    } else if (type === 'addOnService') {
      const addOnCheckboxVal = { ...this.state.addOnCheckboxVal, [number]: checkedValue };
      if (number === 'all') {
        Object.keys(addOnCheckboxVal).forEach((key) => {
          addOnCheckboxVal[key] = checkedValue;
        });
        this.setState({ addOnCheckboxVal, addOnCheckAll: checkedValue });
      } else {
        addOnCheckboxVal[number] = checkedValue;
        this.setState({ addOnCheckboxVal });
      }
    } else {
      const tradeInDevice = { ...this.state.tradeInDevice, [number]: checkedValue };
      this.setState({ tradeInDevice }, () => {
        totalTradeValueCalculation(this.props.getData.serviceNumberDetails,
          this.props.authorableContent.tradeInOffer.formFields.motif.options,
          this.state.tradeInDevice,
        );
      });
    }
  };

  onAddOnAllChangeCheckBox = (event, serviceNumberArray) => {
    const checkedValue = event.target.checked;
    const serviceNumers = serviceNumberArray.map(data => data.serviceNumber);
    const result = Object.fromEntries(serviceNumers.map(arrayData => [arrayData, checkedValue]));
    const finalResult = { ...this.state.addOnCheckboxVal, ...result };
    this.setState({ addOnCheckboxVal: finalResult, addOnCheckAll: checkedValue });
  };

  onPlanAllChangeCheckBox = (event, serviceNumberArray) => {
    const checkedValue = event.target.checked;
    const serviceNumers = serviceNumberArray.map(data => data.serviceNumber);
    const result = Object.fromEntries(serviceNumers.map(arrayData => [arrayData, checkedValue]));
    const finalResult = { ...this.state.planServiceCheckboxVal, ...result };
    this.setState({ planServiceCheckboxVal: finalResult, planServiceCheckAll: checkedValue });
  };

  onWirelessAllChangeCheckBox = (event, serviceNumberArray) => {
    const checkedValue = event.target.checked;
    const serviceNumers = serviceNumberArray.map(data => data.serviceNumber);
    const result = Object.fromEntries(serviceNumers.map(arrayData => [arrayData, checkedValue]));
    const finalResult = { ...this.state.wirelessCheckboxVal, ...result };
    this.setState({ wirelessCheckboxVal: finalResult, wirelessCheckAll: checkedValue });
  };

  onServiceAllChangeCheckBox = (event, serviceNumberArray) => {
    const checkedValue = event.target.checked;
    const serviceNumers = serviceNumberArray.map(data => data.serviceNumber);
    const result = Object.fromEntries(serviceNumers.map(arrayData => [arrayData, checkedValue]));
    const finalResult = { ...this.state.serviceCheckboxVal, ...result };
    this.setState({ serviceCheckboxVal: finalResult, serviceCheckAll: checkedValue });
  };

  onAddOnChangeCheckBox = (event) => {
    const [number, type] = event.target.id.split('-');
    const checkedValue = event.target.checked;
    if (type === 'voice2Text') {
      const voice2TextCheckboxVal = { ...this.state.voice2TextCheckboxVal, [number]: checkedValue };
      voice2TextCheckboxVal[number] = checkedValue;
      this.setState({ voice2TextCheckboxVal });
    } else if (type === 'iPhoneMessageBank') {
      const iPhoneMsgBankCheckboxVal = { ...this.state.iPhoneMsgBankCheckboxVal, [number]: checkedValue };
      iPhoneMsgBankCheckboxVal[number] = checkedValue;
      this.setState({ iPhoneMsgBankCheckboxVal });
    } else if (type === 'oneNumber') {
      const oneNumberCheckboxVal = { ...this.state.oneNumberCheckboxVal, [number]: checkedValue };
      oneNumberCheckboxVal[number] = checkedValue;
      this.setState({ oneNumberCheckboxVal });
    } else if (type === 'monthPass') {
      const monthPassCheckboxVal = { ...this.state.monthPassCheckboxVal, [number]: checkedValue };
      monthPassCheckboxVal[number] = checkedValue;
      this.setState({ monthPassCheckboxVal });
    } else if (type === 'accelerator') {
      const acceleratorCheckboxVal = { ...this.state.acceleratorCheckboxVal, [number]: checkedValue };
      acceleratorCheckboxVal[number] = checkedValue;
      this.setState({ acceleratorCheckboxVal });
    } else if (type === 'demandData') {
      const demandDataCheckboxVal = { ...this.state.demandDataCheckboxVal, [number]: checkedValue };
      demandDataCheckboxVal[number] = checkedValue;
      this.setState({ demandDataCheckboxVal });
    }
  };

  onChangeDropDown = (event, number) => {
    const selectedValue = event.target.getAttribute('data-item');
    const type = event.target.parentElement.parentElement.id.split('-')[0];

    if (selectedValue !== 'NOSELECTION') {
      const serviceNumberDetails = this.props.getData.serviceNumberDetails.find(key => key.serviceNumber === type);
      if (serviceNumberDetails.tradeInValue > 0) {
        this.setState(
          {
            tradeInDevice: { ...this.state.tradeInDevice, [type]: true },
            tradeDropDownValue: { ...this.state.tradeDropDownValue, [type]: selectedValue },
          });
      } else {
        this.setState(
          {
            tradeDropDownValue: { ...this.state.tradeDropDownValue, [type]: selectedValue },
          });
      }
    } else {
      this.setState(
        {
          tradeInDevice: { ...this.state.tradeInDevice, [type]: false },
          tradeDropDownValue: { ...this.state.tradeDropDownValue, [type]: selectedValue },
        });
    }
  };

  onAddOnChangeDropdown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    const type = event.target.parentElement.parentElement.id.split('-')[0];
    const dropdownName =
      event.target.parentElement.parentElement.id.split('-')[1];

    if (dropdownName === 'ido') {
      if (selectedValue !== 'na') {
        this.setState(
          {
            iDOPlanDropDownValue: { ...this.state.iDOPlanDropDownValue, [type]: selectedValue },
          });
      } else {
        this.setState(
          {
            iDOPlanDropDownValue: { ...this.state.iDOPlanDropDownValue, [type]: selectedValue },
          });
      }
    } else if (dropdownName === 'dataTopUp') {
      if (selectedValue !== 'na') {
        this.setState(
          {
            dataTopUpDropDownValue: { ...this.state.dataTopUpDropDownValue, [type]: selectedValue },
          });
      } else {
        this.setState(
          {
            dataTopUpDropDownValue: { ...this.state.dataTopUpDropDownValue, [type]: selectedValue },
          });
      }
    }
  };

  onChangeETCDropdown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    const type = event.target.parentElement.parentElement.id.split('-')[0];

    if (selectedValue !== 'na') {
      this.setState(
        {
          mobileEtcDropDownValue: { ...this.state.mobileEtcDropDownValue, [type]: selectedValue },
        });
    } else {
      this.setState(
        {
          mobileEtcDropDownValue: { ...this.state.mobileEtcDropDownValue, [type]: selectedValue },
        });
    }
  };

  onChangeETCHeaderDropdown = (event, array) => {
    const selectedValue = event.target.getAttribute('data-item');
    const serviceumbers = array.map(number => number.serviceNumber);
    let newMobileEtcDropDownValue = this.state.mobileEtcDropDownValue;

    serviceumbers.forEach((number) => {
      newMobileEtcDropDownValue = { ...newMobileEtcDropDownValue, [number]: selectedValue };
    });

    this.setState({ headerMobileETCValue: selectedValue, mobileEtcDropDownValue: newMobileEtcDropDownValue });
  };

  onPlanSearchTextChange = (event) => {
    const searchText = event.target.value;
    this.setState({ planSearchText: searchText, planDetailsCurrentPage: 0 });
  };

  onSearchTextChange = (event) => {
    const searchText = event.target.value;
    this.setState({ tradeInSearchText: searchText, currentPage: 0 });
  };

  onUnaddressSearchTextChange = (event) => {
    const searchText = event.target.value;
    this.setState({ unaddressSearchText: searchText, unaddressCurrentPage: 0 });
  };

  onWirelessSearchTextChange = (event) => {
    const searchText = event.target.value;
    this.setState({ wirelessSearchText: searchText, wirelessCurrentPage: 0 });
  };

  onAddOnSearchTextChange = (event) => {
    const searchText = event.target.value;
    this.setState({ addOnSearchText: searchText, addOnDetailsCurrentPage: 0 });
  };

  onTabButtonClick = (tabName) => {
    this.setState({ currentTab: tabName });
  };

  onSearchFieldChange = (event) => {
    const selectedKey = event.target.getAttribute('data-item');
    this.setState({ searchFieldSelectedOption: selectedKey, tradeInSearchText: '' });
  }

  onSearchPlanFieldChange = (event) => {
    const selectedKey = event.target.getAttribute('data-item');
    this.setState({ searchPlanSelectedOption: selectedKey, planSearchText: '', planDetailsCurrentPage: 0 });
  }

  onSearchAddOnFieldChange = (event) => {
    const selectedKey = event.target.getAttribute('data-item');
    this.setState({ searchAddOnSelectedOption: selectedKey, addOnSearchText: '', addOnDetailsCurrentPage: 0 });
  }

  onSearchUnaddressFieldChange = (event) => {
    const selectedKey = event.target.getAttribute('data-item');
    this.setState({ searchUnaddressSelectedOption: selectedKey, unaddressSearchText: '', unaddressCurrentPage: 0 });
  }

  onSearchWirelessFieldChange = (event) => {
    const selectedKey = event.target.getAttribute('data-item');
    this.setState({ searchWirelessSelectedOption: selectedKey, wirelessSearchText: '', wirelessCurrentPage: 0 });
  }

  onGetPlanNameDetails = (numb) => {
    const serviceNumbersWithFlag = this.state.serviceNumbersWithFlag;
    const recommededPlans = this.props.authorableContent.recommededPlans;

    const existingPlan = serviceNumbersWithFlag[numb].planName;
    const existingPlanDetails = recommededPlans[`${existingPlan}Staff`];

    if (existingPlanDetails) return existingPlanDetails.title;
    return '';
  };

  getTotalCostAndData = (planName, selectedPlanNumberArr) => {
    const serviceNumbersWithFlag = this.state.serviceNumbersWithFlag;
    const recommededPlans = this.props.authorableContent.recommededPlans;
    let totalFutureDataInclusionPerMonth = this.state.totalFutureDataInclusionPerMonth;
    let totalFutureSpentPerMonth = this.state.totalFutureSpentPerMonth;
    let totalData = 0;
    let totalCost = 0;
    const voiceplanArr = recommededPlans.voicePlanNames.split(',').map(paln => paln.split('|')[0]);
    selectedPlanNumberArr.map((number) => {
      const name = serviceNumbersWithFlag[number].planName;
      const planDetails = recommededPlans[`${name}Staff`];
      if (planDetails !== undefined) {
        totalCost += parseFloat(planDetails.voiceCost);
        totalData += parseFloat(planDetails.dataCost);
      }
      serviceNumbersWithFlag[number].planName = planName;
      if (planName.includes('BroadBand')) {
        serviceNumbersWithFlag[number].dataOnly = true;
      } else if (voiceplanArr.includes(planName)) {
        serviceNumbersWithFlag[number].dataOnly = false;
      }
      return serviceNumbersWithFlag;
    });

    totalFutureSpentPerMonth -= totalCost;
    totalFutureDataInclusionPerMonth -= totalData;

    if (planName !== 'removePlan') {
      const selectedPlanNumberCount = selectedPlanNumberArr.length;
      const planDetails = recommededPlans[`${planName}Staff`];
      totalFutureSpentPerMonth += (planDetails.voiceCost * selectedPlanNumberCount);
      totalFutureDataInclusionPerMonth += (planDetails.dataCost * selectedPlanNumberCount);
    }
    return { totalFutureDataInclusionPerMonth, totalFutureSpentPerMonth, serviceNumbersWithFlag };
  }

  getTotalCostAndDataWireless = (planName, selectedPlanNumberArr) => {
    const serviceNumbersWithFlag = this.state.serviceNumbersWithFlag;
    const recommededPlans = this.props.authorableContent.recommededPlans;
    let totalFutureDataInclusionPerMonth = this.state.totalFutureDataInclusionPerMonth;
    let totalFutureSpentPerMonth = this.state.totalFutureSpentPerMonth;
    let totalData = 0;
    let totalCost = 0;
    selectedPlanNumberArr.map((number) => {
      const name = serviceNumbersWithFlag[number].planName;
      const planDetails = recommededPlans[`${name}Staff`];
      if (planDetails !== undefined) {
        totalCost += parseFloat(planDetails.voiceCost);
        totalData += parseFloat(planDetails.dataCost);
      }
      serviceNumbersWithFlag[number].planName = planName;
      return serviceNumbersWithFlag;
    });

    totalFutureSpentPerMonth -= totalCost;
    totalFutureDataInclusionPerMonth -= totalData;

    if (planName !== 'removePlan') {
      const selectedPlanNumberCount = selectedPlanNumberArr.length;
      const planDetails = recommededPlans[`${planName}Staff`];
      totalFutureSpentPerMonth += (planDetails.voiceCost * selectedPlanNumberCount);
      totalFutureDataInclusionPerMonth += (planDetails.dataCost * selectedPlanNumberCount);
    }
    return { totalFutureDataInclusionPerMonth, totalFutureSpentPerMonth, serviceNumbersWithFlag };
  }

  setCallbackPhonenumber = (phoneNumber) => {
    const callBackPhoneNumber = this.state.callBackPhoneNumber || phoneNumber;
    this.setState({ callBackPhoneNumber });
  }

  handleCallbackPhoneNumberOnChange = (event) => {
    let callBackPhoneNumber = this.state.callBackPhoneNumber || '';
    if (event.target.value.length < 11 && validateNumber(event.target.value)) {
      callBackPhoneNumber = event.target.value;
      let phoneError = false;
      if (callBackPhoneNumber.length === 10) {
        phoneError = !validatePhoneNumberWithStartLetter(callBackPhoneNumber);
      }
      this.setState({ callBackPhoneNumber, IsCallBackPhoneNumberhasError: phoneError });
    }
  }

  handleCallbackPhoneNumberOnBlur = (event) => {
    let IsCallBackPhoneNumberhasError = this.state.IsCallBackPhoneNumberhasError || false;
    IsCallBackPhoneNumberhasError = !validatePhoneNumberWithStartLetter(event.target.value) || event.target.value.length !== 10;
    this.setState({ IsCallBackPhoneNumberhasError });
  }


  movePlanDetails = (name, number) => {
    const existingPlan = this.state.serviceNumbersWithFlag[number].planName;

    const {
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
      planServiceCheckboxVal,
      serviceCheckboxVal,
    } = this.state;

    delete iDOPlanDropDownValue[number];
    delete dataTopUpDropDownValue[number];
    delete mobileEtcDropDownValue[number];
    delete addOnCheckboxVal[number];
    delete voice2TextCheckboxVal[number];
    delete iPhoneMsgBankCheckboxVal[number];
    delete oneNumberCheckboxVal[number];
    delete monthPassCheckboxVal[number];
    delete acceleratorCheckboxVal[number];
    delete demandDataCheckboxVal[number];
    planServiceCheckboxVal[number] = false;
    serviceCheckboxVal[number] = false;

    if (name !== existingPlan) {
      const serviceNumbersPlanDetails = this.state.serviceNumbersPlanDetails.filter(plan =>
        plan.suggestedPlanName !== 'unaddressableServices').map((item) => {
        if (item.serviceNumber === number) {
          return {
            ...item,
            suggestedPlanName: name,
          };
        }
        return item;
      });

      const serviceNumber = [];
      serviceNumber.push(number);
      const { totalFutureDataInclusionPerMonth, totalFutureSpentPerMonth, serviceNumbersWithFlag } = this.getTotalCostAndData(name, serviceNumber);

      const suggestedPlanDetailsNew = this.state.suggestedPlanDetails;

      suggestedPlanDetailsNew.forEach((planItem) => {
        if (planItem.planName === existingPlan) {
          planItem.numbersOnPlan = planItem.numbersOnPlan.filter(enumber => enumber !== number); // eslint-disable-line
        } else if (planItem.planName === name) {
          planItem.numbersOnPlan.push(number);
        }
      });

      this.setState({
        serviceNumbersPlanDetails,
        totalFutureDataInclusionPerMonth,
        totalFutureSpentPerMonth,
        serviceNumbersWithFlag,
        suggestedPlanDetails: suggestedPlanDetailsNew,
        resetBtnDisabled: false,
        optimizeBtnDisabled: false,
      });
    }
    this.setState({
      currentPage: 0,
      unaddressCurrentPage: 0,
      wirelessCurrentPage: 0,
      addOnDetailsCurrentPage: 0,
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
      addOnCheckAll: false,
    });
  };

  moveWirelessPlan = (name, number) => {
    const existingPlan = this.state.serviceNumbersWithFlag[number].planName;
    const {
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      wirelessCheckboxVal,
    } = this.state;

    delete dataTopUpDropDownValue[number];
    delete mobileEtcDropDownValue[number];
    delete addOnCheckboxVal[number];
    wirelessCheckboxVal[number] = false;

    if (name !== existingPlan) {
      const serviceNumbersPlanDetails = this.state.serviceNumbersPlanDetails.filter(plan =>
        plan.suggestedPlanName !== 'unaddressableServices').map((item) => {
        if (item.serviceNumber === number) {
          return {
            ...item,
            suggestedPlanName: name,
          };
        }
        return item;
      });
      const suggestedPlanDetailsNew = this.state.suggestedPlanDetails;

      const serviceNumber = [];
      serviceNumber.push(number);
      const { totalFutureDataInclusionPerMonth, totalFutureSpentPerMonth, serviceNumbersWithFlag } =
        this.getTotalCostAndDataWireless(name, serviceNumber);

      suggestedPlanDetailsNew.forEach((planItem) => {
        if (planItem.planName === existingPlan) {
          planItem.numbersOnPlan = planItem.numbersOnPlan.filter(enumber => enumber !== number); // eslint-disable-line
        } else if (planItem.planName === name) {
          planItem.numbersOnPlan.push(number);
        }
      });

      this.setState({
        serviceNumbersPlanDetails,
        totalFutureDataInclusionPerMonth,
        totalFutureSpentPerMonth,
        serviceNumbersWithFlag,
        suggestedPlanDetails: suggestedPlanDetailsNew,
        resetBtnDisabled: false,
      });
    }
    this.setState({
      currentPage: 0,
      planDetailsCurrentPage: 0,
      unaddressCurrentPage: 0,
      addOnDetailsCurrentPage: 0,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      addOnCheckAll: false,
    });
  };

  downloadCustomerProposal = () => {

  };


  migrateToEpicPlan = (number) => {
    const serviceNumbersWithFlag = this.state.serviceNumbersWithFlag;
    const existingPlan = serviceNumbersWithFlag[number].planName;
    serviceNumbersWithFlag[number].planName = 'mobileEpic';
    const newPlanName = 'mobileEpicStaff';

    const recommededPlans = this.props.authorableContent.recommededPlans;
    let totalFutureDataInclusionPerMonth = this.state.totalFutureDataInclusionPerMonth;
    let totalFutureSpentPerMonth = this.state.totalFutureSpentPerMonth;

    const existingPlanDetails = recommededPlans[`${existingPlan}Staff`];
    const newPlanDetails = recommededPlans[newPlanName];

    const voiceCostDiff = parseFloat(newPlanDetails.voiceCost) - parseFloat(existingPlanDetails.voiceCost);
    const dataCostDiff = parseFloat(newPlanDetails.dataCost) - parseFloat(existingPlanDetails.dataCost);

    totalFutureDataInclusionPerMonth += dataCostDiff;
    totalFutureSpentPerMonth += voiceCostDiff;


    const suggestedPlanDetailsNew = this.state.suggestedPlanDetails;

    const {
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
      planServiceCheckboxVal,
      serviceCheckboxVal,
    } = this.state;

    suggestedPlanDetailsNew.forEach((planItem) => {
      if (planItem.planName === existingPlan) {
        planItem.numbersOnPlan = planItem.numbersOnPlan.filter(enumber => enumber !== number); // eslint-disable-line
      } else if (planItem.planName === 'mobileEpic') {
        planItem.numbersOnPlan.push(number);
      }
      delete iDOPlanDropDownValue[number];
      delete dataTopUpDropDownValue[number];
      delete mobileEtcDropDownValue[number];
      delete addOnCheckboxVal[number];
      delete voice2TextCheckboxVal[number];
      delete iPhoneMsgBankCheckboxVal[number];
      delete oneNumberCheckboxVal[number];
      delete monthPassCheckboxVal[number];
      delete acceleratorCheckboxVal[number];
      delete demandDataCheckboxVal[number];
    });

    planServiceCheckboxVal[number] = false;
    serviceCheckboxVal[number] = false;

    this.setState({
      serviceNumbersWithFlag,
      totalFutureDataInclusionPerMonth,
      totalFutureSpentPerMonth,
      suggestedPlanDetails: suggestedPlanDetailsNew,
      resetBtnDisabled: false,
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
    });
  }

  movePlan = (moveIndex, planName, selectedPlanNumberArr) => {
    const suggestedPlanDetails = this.state.suggestedPlanDetails;

    const serviceNumbersWithFlagData = this.state.serviceNumbersWithFlag;
    const selectedPlanNumberArrUpdated = selectedPlanNumberArr
      .filter(numb => serviceNumbersWithFlagData[numb].planName !== 'unaddressableServices'
        && serviceNumbersWithFlagData[numb].planName !== 'mobileEnterpriseWireless'
        && serviceNumbersWithFlagData[numb].origiPlanName !== 'mobileEnterpriseWireless');
    const suggestedPlanDetailsNew = suggestedPlanDetails.map((plan) => {
      const newPlanData = plan;
      newPlanData.numbersOnPlan = plan.numbersOnPlan.filter(number => !selectedPlanNumberArrUpdated.includes(number));
      return newPlanData;
    });

    const {
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      addOnCheckboxVal,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
      serviceCheckboxVal,
      planServiceCheckboxVal,
      wirelessCheckboxVal,
    } = this.state;

    /** START remove  selectedPlanNumberArr from  includeIphone and tradeDropDownValue  */
    const includeIphone = this.state.includeIphone;
    const tradeDropDownValue = this.state.tradeDropDownValue;
    const tradeInDevice = this.state.tradeInDevice;
    selectedPlanNumberArrUpdated.map((number) => {
      if (Object.keys(includeIphone).includes(number)) {
        delete includeIphone[number];
      }
      if (Object.keys(tradeDropDownValue).includes(number)) {
        delete tradeDropDownValue[number];
      }
      if (Object.keys(tradeInDevice).includes(number)) {
        delete tradeInDevice[number];
      }

      delete iDOPlanDropDownValue[number];
      delete dataTopUpDropDownValue[number];
      delete mobileEtcDropDownValue[number];
      delete addOnCheckboxVal[number];
      delete voice2TextCheckboxVal[number];
      delete iPhoneMsgBankCheckboxVal[number];
      delete oneNumberCheckboxVal[number];
      delete monthPassCheckboxVal[number];
      delete acceleratorCheckboxVal[number];
      delete demandDataCheckboxVal[number];
      return number;
    });
    this.setState({ includeIphone, tradeDropDownValue, tradeInDevice });
    /** END */

    /** START calculate total data and cost */
    const { totalFutureDataInclusionPerMonth,
      totalFutureSpentPerMonth,
      serviceNumbersWithFlag } = this.getTotalCostAndData(planName, selectedPlanNumberArrUpdated);
    /** END */
    suggestedPlanDetailsNew[moveIndex].numbersOnPlan.push(...selectedPlanNumberArrUpdated);

    Object.keys(addOnCheckboxVal).forEach((key) => {
      addOnCheckboxVal[key] = false;
    });

    Object.keys(serviceCheckboxVal).forEach((key) => {
      serviceCheckboxVal[key] = false;
    });

    Object.keys(planServiceCheckboxVal).forEach((key) => {
      planServiceCheckboxVal[key] = false;
    });

    Object.keys(wirelessCheckboxVal).forEach((key) => {
      wirelessCheckboxVal[key] = false;
    });

    this.setState({
      suggestedPlanDetails: suggestedPlanDetailsNew,
      serviceNumbersWithFlag,
      totalFutureDataInclusionPerMonth,
      totalFutureSpentPerMonth,
      currentPage: 0,
      planDetailsCurrentPage: 0,
      unaddressCurrentPage: 0,
      wirelessCurrentPage: 0,
      addOnDetailsCurrentPage: 0,
      iDOPlanDropDownValue,
      dataTopUpDropDownValue,
      mobileEtcDropDownValue,
      voice2TextCheckboxVal,
      iPhoneMsgBankCheckboxVal,
      oneNumberCheckboxVal,
      monthPassCheckboxVal,
      acceleratorCheckboxVal,
      demandDataCheckboxVal,
      updatedSummaryTable: true,
      planServiceCheckboxVal,
      planServiceCheckAll: false,
      serviceCheckboxVal,
      serviceCheckAll: false,
      wirelessCheckboxVal,
      wirelessCheckAll: false,
      addOnCheckboxVal,
      addOnCheckAll: false,
    });
  };

  updateStateData = (defaultData, callbackfunction) => {
    this.setState(defaultData, callbackfunction);
  };

  submitAMCOptimizePlanData = (updatedPlan) => {
    const { recommededPlans } = this.props.authorableContent;
    const { suggestedPlanDetails, serviceNumbersWithFlag } = this.state;

    const mobileDevicesNumbers = updatedPlan.filter(plan => plan.dataOnly === false)
      .map(plan => plan.numbersOnPlan).reduce((a, b) => a.concat(b), []);
    const dataDevicesNumbers = updatedPlan.filter(plan => plan.dataOnly === true)
      .map(plan => plan.numbersOnPlan).reduce((a, b) => a.concat(b), []);

    const totalDevices = mobileDevicesNumbers.length + dataDevicesNumbers.length;

    this.setState({
      serviceCheckboxVal: {},
      planServiceCheckboxVal: {},
      wirelessCheckboxVal: {},
      addOnCheckboxVal: {},
    });

    if (totalDevices > parseInt(recommededPlans.optimizationThreshold, 10)) { // perform FE optimization
      this.setState({ feOptimizerInProgress: true });
      setTimeout(() => {
        const optimizedResults = getFEOptimizeResult(updatedPlan,
          recommededPlans,
          this.props.getData.totalFutureSpentPerMonth);
        const optimizedResponse = convertOptimizedResultForFE(optimizedResults, mobileDevicesNumbers, dataDevicesNumbers);
        const optimizeDetails = getOptimizePlanDetails(optimizedResponse,
          suggestedPlanDetails,
          serviceNumbersWithFlag);
        this.updateStateData({
          suggestedPlanDetails: optimizeDetails.suggestedPlan,
          serviceNumbersWithFlag: optimizeDetails.updatedServiceNumbersWithFlag,
          totalFutureSpentPerMonth: parseFloat(optimizeDetails.totalFutureSpentPerMonth),
          totalFutureDataInclusionPerMonth: optimizeDetails.totalFutureDataInclusionPerMonth,
          feOptimizerInProgress: false,
          iDOPlanDropDownValue: {},
          dataTopUpDropDownValue: {},
          mobileEtcDropDownValue: {},
          voice2TextCheckboxVal: {},
          iPhoneMsgBankCheckboxVal: {},
          oneNumberCheckboxVal: {},
          monthPassCheckboxVal: {},
          acceleratorCheckboxVal: {},
          demandDataCheckboxVal: {},
          currentTab: 'tab1',
        });
      }, 2000);
    } else { // BE optmization
      const { submitAMCOptimizePlanData } = this.props.actions;
      const postCallData = preparePostCallForOptimizePlan(updatedPlan, recommededPlans);

      const mobileWirelessVoiceCost = parseInt(recommededPlans.mobileEnterpriseWirelessStaff.voiceCost, 10);
      const mobileWirelessDataCost = parseInt(recommededPlans.mobileEnterpriseWirelessStaff.dataCost, 10);

      let mobileWirelessServicesCount = 0;
      const mobileWirelessPlan = updatedPlan.find(plan => plan.planName === 'mobileEnterpriseWireless');
      if (mobileWirelessPlan) {
        mobileWirelessServicesCount = mobileWirelessPlan.numbersOnPlan.length;
      }
      postCallData.recommendedTotalCost = this.props.getData.totalFutureSpentPerMonth - (mobileWirelessServicesCount * mobileWirelessVoiceCost);
      postCallData.recommendedTotalData = this.props.getData.totalFutureDataInclusionPerMonth -
        (mobileWirelessServicesCount * mobileWirelessDataCost);
      submitAMCOptimizePlanData(postCallData);
    }
  }

  resetAllPlan = () => {
    const suggestedNumberDetails = getSuggestedPlanDetailsFromServiceDetails(this.props.getData.serviceNumberDetails,
      this.props.authorableContent.recommededPlans);
    const serviceNumbersPlanDetailsNormal = this.props.getData.serviceNumberDetails
      .filter(item => item.suggestedPlanName !== 'unaddressableServices');
    const serviceNumbersPlanDetailsUnAddress = this.props.getData.serviceNumberDetails
      .filter(item => item.suggestedPlanName === 'unaddressableServices');
    const serviceNumbersPlanDetails = [...serviceNumbersPlanDetailsNormal, ...serviceNumbersPlanDetailsUnAddress];

    this.setState({
      serviceCheckboxVal: {},
      planServiceCheckboxVal: {},
      wirelessCheckboxVal: {},
      addOnCheckboxVal: {},
    });

    this.updateStateData({
      suggestedPlanDetails: suggestedNumberDetails.suggestedPlan,
      serviceNumbersWithFlag: suggestedNumberDetails.serviceNumbersWithFlag,
      totalFutureSpentPerMonth: parseFloat(this.props.getData.totalFutureSpentPerMonth),
      totalFutureDataInclusionPerMonth: this.props.getData.totalFutureDataInclusionPerMonth,
      tradeDropDownValue: {},
      tradeInDevice: {},
      resetBtnDisabled: true,
      serviceNumbersPlanDetails,
      currentPage: 0,
      planDetailsCurrentPage: 0,
      unaddressCurrentPage: 0,
      wirelessCurrentPage: 0,
      addOnDetailsCurrentPage: 0,
      iDOPlanDropDownValue: {},
      dataTopUpDropDownValue: {},
      mobileEtcDropDownValue: {},
      voice2TextCheckboxVal: {},
      iPhoneMsgBankCheckboxVal: {},
      oneNumberCheckboxVal: {},
      monthPassCheckboxVal: {},
      acceleratorCheckboxVal: {},
      demandDataCheckboxVal: {},
    });
  }

  handlePlanModal = () => {
    this.setState({ planModalOpen: true });
  }

  planModalClose = () => {
    this.setState({ planModalOpen: false });
  }

  render() {
    if (this.props.dataLoaded) {
      const {
        ngm: {
          criteria1Title,
          criteria1Description,
          topImagePath,
          alreadySubmittedHeading,
          whatYouNeedHeading,
        },
        confirmDetails: {
          accountNumberText,
          accountNameText,
          abnText,
        },
        confirmation: {
          heading: confirmHeading,
          description: confirmDescription,

        },
        recommededPlans,
        recommededPlans: {
          recommededPlanDescription,
          estimatedTotalMonthlyCharges: {
            title,
            tooltip: toolTip,
            monthText: perLabel,
            inclGSTText,
          },
          newEstimatedTotalMonthlyCharges: {
            title: newTitle,
            tooltip: newToolTip,
            monthText: newPerLabel,
            inclGSTText: newPlanInclGSTText,
          },
          gbText,
          totalSpendPerMonth: totalMonthText,
          totalDataInclusion: totalInclusionText,
          searchDropdownText,
          searchClearText,
          voiceDataTab,
          wirelessDataTab,
          unaddressableDataTab,
          deviceDataTab,
          addOnTab,
          digitalReadyPreText,
          digitalReadyBlankText,
        },
        explanationSection,
        tradeInOffer,
        planOverview,
        requestCallBack: {
          requestCallBackModal: {
            title: requestCallbackOfflineTitle,
            text: requestCallbackOfflineText,
            yesText: requestCallbackOfflineYesText,
            formFields: requestCallbackOfflineFormfields,
          },
          thankYouModal: {
            title: callbackThankYouTitle,
            text: callbackThankYouText,
          },
          floatingCtaCallBack: {
            icon: callbackIcon,
            text: callbackText,
          },
          liveChatModal: {
            title: liveChatModalTitle,
            text: liveChatModalText,
            callbackText: callBackButtontext,
            chatNowText: chatNowButtonText,
          },
        },
      } = this.props.authorableContent;

      const {
        customerAccountName,
        customerAbn,
        optimizeInProgress,
        optimizePlanData,
        alreadySubmittedDate,
        alreadySubmitted,
        formSubmitted,
        getData: {
          totalCurrentDataInclusionPerMonth,
          totalCurrentSpentPerMonth,
          digitalReadiness,
          currentFundAllowance,
        },
      } = this.props;

      const initialHeader = {
        heading: criteria1Title,
        description: renderHTML(stripStartingAndEndingPTags(criteria1Description)),
      };

      const estimatedTotalCurrentMonthlyCost = {
        title,
        toolTip,
        perLabel,
        totalCost: parseFloat(totalCurrentSpentPerMonth),
        dataInclusion: totalCurrentDataInclusionPerMonth,
        inclGSTText,
        gbText,
        totalMonthText,
        totalInclusionText,
      };

      const estimatedTotalNewMonthlyCost = {
        title: newTitle,
        toolTip: newToolTip,
        perLabel: newPerLabel,
        totalCost: this.state.totalFutureSpentPerMonth,
        dataInclusion: this.state.totalFutureDataInclusionPerMonth,
        inclGSTText: newPlanInclGSTText,
        gbText,
        totalMonthText,
        totalInclusionText,
        asterisk: '*',
      };

      const callbackCta = [
        {
          icon: callbackIcon,
          text: callbackText,
          onCtaClick: () => {
            this.onOpenRequestCallBack();
          },
        },
      ];

      const { tradeDropDownValue, contractTerm, tradeInDevice, suggestedPlanDetails } = this.state;

      const motifValue = calculateMotif(tradeInOffer.formFields, suggestedPlanDetails);

      const averageAfsValue = calculateAverageAfsPerMonth(tradeInOffer.formFields.afsCost,
        tradeDropDownValue, contractTerm);

      const moorUpPerServiceValue = calculateMonthlyMoorupPerService(tradeInDevice,
        this.props.getData.serviceNumberDetails, tradeDropDownValue, contractTerm);

      const avgPhoneCost = (averageAfsValue - motifValue - moorUpPerServiceValue) > 0 ?
        (averageAfsValue - motifValue - moorUpPerServiceValue) : 0;

      const rrpCost = calculateTotalSavingPerMonth(tradeInOffer.formFields.phoneCost,
        tradeDropDownValue, contractTerm);
      const savingCost = calculateTotalSavingPerMonth(tradeInOffer.formFields.phoneCost,
        tradeDropDownValue, contractTerm) - avgPhoneCost;

      const tradeInDeviceCount = Object.values(this.state.tradeInDevice).filter(val => val !== false).length;
      const newDeviceCount = Object.values(this.state.tradeDropDownValue).filter(val => val !== 'NOSELECTION').length;

      const totalTradeInValue = calculateTotalTradeInValue(this.state.tradeInDevice,
        this.props.getData.serviceNumberDetails);

      const planArr = recommededPlans.voicePlanNames.split(',').map(paln => paln.split('|')[0]);
      const filterServiceNumberArr = this.props.getData.serviceNumberDetails.filter(numbers =>
        this.state.serviceNumbersWithFlag[numbers.serviceNumber] &&
        planArr.includes(this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName) &&
        this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName !== 'removePlan');

      const sortedFilterServiceNumberArr = filterServiceNumberArr.sort((a, b) => {
        if (this.state.tradeInOfferSorting.sortingField === 'number') {
          if (this.state.tradeInOfferSorting.numberSortType === 'ASC') {
            return parseInt(a.serviceNumber, 10) - parseInt(b.serviceNumber, 10);
          }
          return parseInt(b.serviceNumber, 10) - parseInt(a.serviceNumber, 10);
        } else if (this.state.tradeInOfferSorting.sortingField === 'userName') {
          const nameA = a.userName.toUpperCase();
          const nameB = b.userName.toUpperCase();
          if (this.state.tradeInOfferSorting.userSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.tradeInOfferSorting.userSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.tradeInOfferSorting.sortingField === 'deviceType') {
          const nameA = a.deviceType.toUpperCase();
          const nameB = b.deviceType.toUpperCase();
          if (this.state.tradeInOfferSorting.deviceSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.tradeInOfferSorting.deviceSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.tradeInOfferSorting.sortingField === 'tradeInValue') {
          if (this.state.tradeInOfferSorting.valueSortType === 'ASC') {
            return a.tradeInValue - b.tradeInValue;
          }
          return b.tradeInValue - a.tradeInValue;
        }
        return b.tradeInValue - a.tradeInValue;
      });

      let searchResults = [];
      if (this.state.searchFieldSelectedOption === 'tradeineligible') {
        searchResults = sortedFilterServiceNumberArr.filter(numbers => parseInt(numbers.tradeInValue, 10) > 0);
      } else if (this.state.searchFieldSelectedOption === 'tradeinnoteligible') {
        searchResults = sortedFilterServiceNumberArr.filter(numbers => parseInt(numbers.tradeInValue, 10) === 0);
      } else if (this.state.searchFieldSelectedOption !== 'nosearch' && this.state.tradeInSearchText.length > 0) {
        if (this.state.searchFieldSelectedOption === 'number') {
          searchResults = sortedFilterServiceNumberArr.filter(numbers => numbers.serviceNumber.includes(this.state.tradeInSearchText));
        } else if (this.state.searchFieldSelectedOption === 'username') {
          searchResults = sortedFilterServiceNumberArr
            .filter(numbers => numbers.userName.toLowerCase().includes(this.state.tradeInSearchText.toLowerCase()));
        } else if (this.state.searchFieldSelectedOption === 'device') {
          searchResults = sortedFilterServiceNumberArr
            .filter(numbers => numbers.deviceType.toLowerCase().includes(this.state.tradeInSearchText.toLowerCase()));
        } else if (this.state.searchFieldSelectedOption === 'imeinumber') {
          searchResults = sortedFilterServiceNumberArr.filter(numbers => numbers.imeiNumber.includes(this.state.tradeInSearchText));
        } else {
          searchResults = sortedFilterServiceNumberArr;
        }
      } else {
        searchResults = sortedFilterServiceNumberArr;
      }

      const filterPlanServiceNumberArr = this.state.serviceNumbersPlanDetails.filter(numbers =>
        this.state.serviceNumbersWithFlag[numbers.serviceNumber] &&
        this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName !== 'unaddressableServices' &&
        this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName !== 'mobileEnterpriseWireless');

      const sortedPlanFilterArr = filterPlanServiceNumberArr.sort((a, b) => {
        if (this.state.planSorting.sortingField === 'number') {
          if (this.state.planSorting.numberSortType === 'ASC') {
            return parseInt(a.serviceNumber, 10) - parseInt(b.serviceNumber, 10);
          }
          return parseInt(b.serviceNumber, 10) - parseInt(a.serviceNumber, 10);
        } else if (this.state.planSorting.sortingField === 'userName') {
          const nameA = a.userName.toUpperCase();
          const nameB = b.userName.toUpperCase();
          if (this.state.planSorting.userSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.planSorting.userSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.planSorting.sortingField === 'currentPlanName') {
          const nameA = a.currentPlan.toUpperCase();
          const nameB = b.currentPlan.toUpperCase();
          if (this.state.planSorting.currentPlanNameSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.planSorting.currentPlanNameSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.planSorting.sortingField === 'currentPlanCost') {
          if (this.state.planSorting.currentPlanCostSortType === 'ASC') {
            return parseFloat(a.currentPlanCost) - parseFloat(b.currentPlanCost);
          }
          return parseFloat(b.currentPlanCost) - parseFloat(a.currentPlanCost);
        } else if (this.state.planSorting.sortingField === 'dataUsage') {
          if (this.state.planSorting.dataUsageSortType === 'ASC') {
            return parseInt(a.currentData, 10) - parseInt(b.currentData, 10);
          }
          return parseInt(b.currentData, 10) - parseInt(a.currentData, 10);
        }
        return b.serviceNumber - a.serviceNumber;
      });

      let planSearchResults = [];

      if (this.state.searchPlanSelectedOption !== 'nosearch') {
        if (this.state.searchPlanSelectedOption === 'mobileEssential') {
          planSearchResults = sortedPlanFilterArr.filter(plans => plans.suggestedPlanName === 'mobileEssential');
        } else if (this.state.searchPlanSelectedOption === 'mobileEnhanced') {
          planSearchResults = sortedPlanFilterArr.filter(plans => plans.suggestedPlanName === 'mobileEnhanced');
        } else if (this.state.searchPlanSelectedOption === 'mobileEpic') {
          planSearchResults = sortedPlanFilterArr.filter(plans => plans.suggestedPlanName === 'mobileEpic');
        } else if (this.state.searchPlanSelectedOption === 'mobileBroadBandEssential') {
          planSearchResults = sortedPlanFilterArr.filter(plans => plans.suggestedPlanName === 'mobileBroadBandEssential');
        } else if (this.state.searchPlanSelectedOption === 'mobileBroadBandEnhanced') {
          planSearchResults = sortedPlanFilterArr.filter(plans => plans.suggestedPlanName === 'mobileBroadBandEnhanced');
        } else if (this.state.searchPlanSelectedOption === 'mobileBroadBandEpic') {
          planSearchResults = sortedPlanFilterArr.filter(plans => plans.suggestedPlanName === 'mobileBroadBandEpic');
        } else if (this.state.searchPlanSelectedOption === 'allData') {
          planSearchResults = sortedPlanFilterArr.filter(plans => plans.dataOnly);
        } else if (this.state.searchPlanSelectedOption === 'allVoice') {
          planSearchResults = sortedPlanFilterArr.filter(plans => !plans.dataOnly);
        } else if (this.state.searchPlanSelectedOption === 'number') {
          planSearchResults = sortedPlanFilterArr.filter(numbers => numbers.serviceNumber.includes(this.state.planSearchText));
        } else if (this.state.searchPlanSelectedOption === 'username') {
          planSearchResults = sortedPlanFilterArr
            .filter(numbers => numbers.userName.toLowerCase().includes(this.state.planSearchText.toLowerCase()));
        } else if (this.state.searchPlanSelectedOption === 'currentplan') {
          planSearchResults = sortedPlanFilterArr
            .filter(numbers => numbers.currentPlan.toLowerCase().includes(this.state.planSearchText.toLowerCase()));
        } else {
          planSearchResults = sortedPlanFilterArr;
        }
      } else {
        planSearchResults = sortedPlanFilterArr;
      }

      const filterAddOnServiceNumberArr = this.state.serviceNumbersPlanDetails.filter(numbers =>
        this.state.serviceNumbersWithFlag[numbers.serviceNumber] &&
        this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName !== 'removePlan' &&
        this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName !== 'unaddressableServices');

      let addOnSearchResults = [];

      if (this.state.searchAddOnSelectedOption !== 'nosearch') {
        if (this.state.searchAddOnSelectedOption === 'number') {
          addOnSearchResults = filterAddOnServiceNumberArr.filter(numbers => numbers.serviceNumber.includes(this.state.addOnSearchText));
        } else if (this.state.searchAddOnSelectedOption === 'username') {
          addOnSearchResults = filterAddOnServiceNumberArr
            .filter(numbers => numbers.userName.toLowerCase().includes(this.state.addOnSearchText.toLowerCase()));
        } else {
          addOnSearchResults = filterAddOnServiceNumberArr;
        }
      } else {
        addOnSearchResults = filterAddOnServiceNumberArr;
      }

      const filterUnaddressServiceNumberArr = this.props.getData.serviceNumberDetails.filter(numbers =>
        this.state.serviceNumbersWithFlag[numbers.serviceNumber] &&
        this.state.serviceNumbersWithFlag[numbers.serviceNumber].planName === 'unaddressableServices');

      const sortedUnaddressFilterArr = filterUnaddressServiceNumberArr.sort((a, b) => {
        if (this.state.unaddressSorting.sortingField === 'number') {
          if (this.state.unaddressSorting.numberSortType === 'ASC') {
            return parseInt(a.serviceNumber, 10) - parseInt(b.serviceNumber, 10);
          }
          return parseInt(b.serviceNumber, 10) - parseInt(a.serviceNumber, 10);
        } else if (this.state.unaddressSorting.sortingField === 'userName') {
          const nameA = a.userName.toUpperCase();
          const nameB = b.userName.toUpperCase();
          if (this.state.unaddressSorting.userSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.unaddressSorting.userSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.unaddressSorting.sortingField === 'currentPlanName') {
          const nameA = a.unaddressableCurrentPlan.toUpperCase();
          const nameB = b.unaddressableCurrentPlan.toUpperCase();
          if (this.state.unaddressSorting.currentPlanNameSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.unaddressSorting.currentPlanNameSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.unaddressSorting.sortingField === 'currentPlanCost') {
          if (this.state.unaddressSorting.currentPlanCostSortType === 'ASC') {
            return parseFloat(a.currentPlanCost) - parseFloat(b.currentPlanCost);
          }
          return parseFloat(b.currentPlanCost) - parseFloat(a.currentPlanCost);
        } else if (this.state.unaddressSorting.sortingField === 'dataUsage') {
          if (this.state.unaddressSorting.dataUsageSortType === 'ASC') {
            return parseFloat(a.dataUsage) - parseFloat(b.dataUsage);
          }
          return parseFloat(b.dataUsage) - parseFloat(a.dataUsage);
        } else if (this.state.unaddressSorting.sortingField === 'treatment') {
          const nameA = a.treatmentName.toUpperCase();
          const nameB = b.treatmentName.toUpperCase();
          if (this.state.unaddressSorting.treatmentSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.unaddressSorting.treatmentSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.unaddressSorting.sortingField === 'deviceType') {
          const nameA = a.deviceType.toUpperCase();
          const nameB = b.deviceType.toUpperCase();
          if (this.state.unaddressSorting.deviceSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.unaddressSorting.deviceSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        }
        return b.serviceNumber - a.serviceNumber;
      });

      let unaddressSearchResults = [];

      if (this.state.searchUnaddressSelectedOption === 'number') {
        unaddressSearchResults = sortedUnaddressFilterArr.filter(numbers => numbers.serviceNumber.includes(this.state.unaddressSearchText));
      } else if (this.state.searchUnaddressSelectedOption === 'username') {
        unaddressSearchResults = sortedUnaddressFilterArr
          .filter(numbers => numbers.userName.toLowerCase().includes(this.state.unaddressSearchText.toLowerCase()));
      } else if (this.state.searchUnaddressSelectedOption === 'currentplan') {
        unaddressSearchResults = sortedUnaddressFilterArr
          .filter(numbers => numbers.unaddressableCurrentPlan.toLowerCase().includes(this.state.unaddressSearchText.toLowerCase()));
      } else {
        unaddressSearchResults = sortedUnaddressFilterArr;
      }

      const filterWirelessServiceNumberArr = this.state.serviceNumbersPlanDetails.filter(numbers =>
        this.state.serviceNumbersWithFlag[numbers.serviceNumber] &&
        this.state.serviceNumbersWithFlag[numbers.serviceNumber].origiPlanName === 'mobileEnterpriseWireless');

      const sortedWirelessFilterArr = filterWirelessServiceNumberArr.sort((a, b) => {
        if (this.state.wirelessSorting.sortingField === 'number') {
          if (this.state.wirelessSorting.numberSortType === 'ASC') {
            return parseInt(a.serviceNumber, 10) - parseInt(b.serviceNumber, 10);
          }
          return parseInt(b.serviceNumber, 10) - parseInt(a.serviceNumber, 10);
        } else if (this.state.wirelessSorting.sortingField === 'userName') {
          const nameA = a.userName.toUpperCase();
          const nameB = b.userName.toUpperCase();
          if (this.state.wirelessSorting.userSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.wirelessSorting.userSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.wirelessSorting.sortingField === 'currentPlanName') {
          const nameA = a.currentPlan.toUpperCase();
          const nameB = b.currentPlan.toUpperCase();
          if (this.state.wirelessSorting.currentPlanNameSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.wirelessSorting.currentPlanNameSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.wirelessSorting.sortingField === 'deviceType') {
          const nameA = a.deviceType.toUpperCase();
          const nameB = b.deviceType.toUpperCase();
          if (this.state.wirelessSorting.deviceSortType === 'ASC') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else if (this.state.wirelessSorting.deviceSortType === 'DESC') {
            if (nameB < nameA) {
              return -1;
            } else if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
          return 0;
        } else if (this.state.wirelessSorting.sortingField === 'currentPlanCost') {
          if (this.state.wirelessSorting.currentPlanCostSortType === 'ASC') {
            return parseFloat(a.currentPlanCost) - parseFloat(b.currentPlanCost);
          }
          return parseFloat(b.currentPlanCost) - parseFloat(a.currentPlanCost);
        } else if (this.state.wirelessSorting.sortingField === 'dataUsage') {
          if (this.state.wirelessSorting.dataUsageSortType === 'ASC') {
            return parseInt(a.dataUsage, 10) - parseInt(b.dataUsage, 10);
          }
          return parseInt(b.dataUsage, 10) - parseInt(a.dataUsage, 10);
        }
        return b.serviceNumber - a.serviceNumber;
      });

      let wirelessSearchResults = [];

      if (this.state.searchWirelessSelectedOption === 'number') {
        wirelessSearchResults = sortedWirelessFilterArr.filter(numbers => numbers.serviceNumber.includes(this.state.wirelessSearchText));
      } else if (this.state.searchWirelessSelectedOption === 'username') {
        wirelessSearchResults = sortedWirelessFilterArr
          .filter(numbers => numbers.userName.toLowerCase().includes(this.state.wirelessSearchText.toLowerCase()));
      } else {
        wirelessSearchResults = sortedWirelessFilterArr;
      }

      const { feOptimizerInProgress } = this.state;

      const mobileDevicesNumbers = suggestedPlanDetails.filter(plan => plan.dataOnly === false)
        .map(plan => plan.numbersOnPlan).reduce((a, b) => a.concat(b), []);
      const dataDevicesNumbers = suggestedPlanDetails.filter(plan => plan.dataOnly === true)
        .map(plan => plan.numbersOnPlan).reduce((a, b) => a.concat(b), []);
      let wirelessCount = 0;
      const wirelessPlan = suggestedPlanDetails.length > 0 &&
        suggestedPlanDetails.find(plan => plan.planName === 'mobileEnterpriseWireless');
      if (wirelessPlan) {
        wirelessCount = wirelessPlan.numbersOnPlan.length;
      }
      const totalAMPlanDevices = mobileDevicesNumbers.length + dataDevicesNumbers.length + wirelessCount;

      const fundContributionValue = motifValue * totalAMPlanDevices * this.state.contractTerm;

      const currentDeviceList = getCurrentDevicesListFromData(this.props.getData.serviceNumberDetails);
      const currentPlanList = getCurrentPlanListFromData(this.props.getData.serviceNumberDetails);

      const unaddressCurrentPlanList = getUnaddressCurrentPlanList(this.props.getData.serviceNumberDetails);
      const unaddressCurrentDevicesList = getUnaddressCurrentDevicesList(this.props.getData.serviceNumberDetails);
      const unaddressTreatmentList = getUnaddressTreatmentList(this.props.getData.serviceNumberDetails);

      const wirelessCurrentPlanList = getWirelessCurrentPlanList(this.props.getData.serviceNumberDetails);
      const wirelessCurrentDevicesList = getWirelessCurrentDevicesList(this.props.getData.serviceNumberDetails);

      const currentFundValue = currentFundAllowance;

      const addonCosts = calculateAddonCosts(
        this.state.iDOPlanDropDownValue,
        this.state.voice2TextCheckboxVal,
        this.state.iPhoneMsgBankCheckboxVal,
        this.state.oneNumberCheckboxVal,
        this.state.monthPassCheckboxVal,
        this.state.acceleratorCheckboxVal,
        this.state.dataTopUpDropDownValue,
        this.state.demandDataCheckboxVal,
        tradeInOffer,
        this.state.serviceNumbersWithFlag,
      );

      const requestCallBackLiveChatOnlineAuthorableContent = {
        liveChatModalTitle,
        liveChatModalText,
        callBackButtontext,
        chatNowButtonText,
        callbackThankYouTitle,
        callbackThankYouText,
      };

      const requestCallBackOfflineAuthorableContent = {
        requestCallbackOfflineTitle,
        requestCallbackOfflineText,
        requestCallbackOfflineYesText,
        requestCallbackOfflineFormfields,
        callbackThankYouTitle,
        callbackThankYouText,
      };

      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = today.getMonth();
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const mmm = monthNames[mm];
      const yyyy = today.getFullYear();
      const finalDate = `${dd} ${mmm} ${yyyy}`;

      const submissionCompletedText = `${alreadySubmittedHeading} ${finalDate}`;
      const alreadySubmittedDescription = `${alreadySubmittedHeading} ${alreadySubmittedDate}`;

      return (
        <AppWrapper>
          <div className="amc-homepage root-container container ffwd-homepage body18">
            <AccountDetails
              accountNumberText={accountNumberText}
              accountNameText={accountNameText}
              abnText={abnText}
              customerAccountName={customerAccountName}
              customerAccountNumber={this.props.getData.dealerNameCode}
              customerAbn={customerAbn}
            />
            {(alreadySubmitted || formSubmitted) &&
              <GenericAlert
                name="primary-title"
                description={formSubmitted ? submissionCompletedText : alreadySubmittedDescription}
                showBackground
              />
            }
            <FloatingCta ctas={callbackCta} />
            <RequestCallBackModalOffline
              customerContactPhone={this.state.callBackPhoneNumber}
              modalIsOpen={this.state.callBackRequestLiveChatOfflineModalIsOpen}
              onCloseDialogBox={this.onCloseRequestCallBackOffline}
              onRequestCallback={this.onRequestCallBackCompleted}
              authorableContent={requestCallBackOfflineAuthorableContent}
              callBackRequestCompleted={this.state.callBackRequestCompleted}
              IsCallBackPhoneNumberhasError={this.state.IsCallBackPhoneNumberhasError}
              onBlur={this.handleCallbackPhoneNumberOnBlur}
              onChange={this.handleCallbackPhoneNumberOnChange}
            />
            <RequestCallBackModalOnline
              modalIsOpen={this.state.callBackRequestLiveChatOnlineModalIsOpen}
              onCloseDialogBox={this.onCloseRequestCallBackOffline}
              onRequestCallback={this.onOnlineRequestCallBack}
              onStartLiveChat={this.onStartLiveChat}
              authorableContent={requestCallBackLiveChatOnlineAuthorableContent}
              callBackRequestCompleted={this.state.callBackRequestCompleted}
            />
            <div className="row">
              <div className={`${(topImagePath !== undefined && topImagePath !== '') ? 'col-lg-6' : 'col-lg-12'} col-sm-12`}>
                <ViewHeader content={initialHeader} customOverrideClass="heading40" />
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <Button
                      variant="primary"
                      onClick={this.handlePlanModal}
                      size="medium"
                      iconPosition="right"
                      className="test-class"
                    >
                      {whatYouNeedHeading}
                    </Button>
                  </div>
                </div>
              </div>
              {topImagePath !== undefined && topImagePath !== '' &&
                <div className="col-lg-6 col-sm-12 pl-sm-0 pr-sm-0 header-right-img text-center">
                  <img alt={topImagePath} width="100%" src={`${IMAGE_BASE_LINK}/${topImagePath}`} />
                </div>
              }
            </div>
            <Modal
              isOpen={this.state.planModalOpen}
              onShowModal={this.planModalClose}
              size="large"
              className="plan-details-modal"
            >
              <Modal.Header>
                {planOverview && planOverview.heading}
              </Modal.Header>
              <Modal.Body>
                <PlanDetails
                  planOverview={planOverview}
                />
              </Modal.Body>
            </Modal>


            {this.state.toggleRecommededPlan &&
              <React.Fragment>
                <OptimizePlanTableView
                  recommededPlans={recommededPlans}
                  recommededPlanDescription={recommededPlanDescription}
                  planDetails={this.state.currentPlanDetails}
                  suggestedPlanDetails={this.state.suggestedPlanDetails}
                  estimatedTotalCurrentMonthlyCost={estimatedTotalCurrentMonthlyCost}
                  estimatedTotalNewMonthlyCost={estimatedTotalNewMonthlyCost}
                  numberSearchDropdown
                  searchDropdownText={searchDropdownText}
                  searchClearText={searchClearText}
                  customHeadingClass="heading34"
                  recommendationTier={this.state.recommendedPlanType}
                  setSearchUsedValue={this.updateStateData}
                  serviceNumbersWithFlag={this.state.serviceNumbersWithFlag}
                  submitAMSOptimizePlanData={this.submitAMCOptimizePlanData}
                  optimizeInProgress={optimizeInProgress || feOptimizerInProgress}
                  optimizePlanData={optimizePlanData}
                  movePlan={this.movePlan}
                  resetAllPlan={this.resetAllPlan}
                  resetBtnDisabled={this.state.resetBtnDisabled}
                  optimizeBtnDisabled={this.state.optimizeBtnDisabled}
                />
                <SummaryDetails
                  summaryTitle={tradeInOffer.headingText}
                  summaryText={stripStartingAndEndingPTags(tradeInOffer.descriptionText)}
                  customHeadingClass="heading34"
                />
                <div className="row tab-section">
                  <div className={`col-3 ${this.state.currentTab === 'tab1' ? 'active-tab' : 'not-active-tab'}`}>
                    <Button
                      variant="secondary"
                      size="medium"
                      state="app"
                      onClick={() => this.onTabButtonClick('tab1')}
                    >{voiceDataTab}
                    </Button>
                  </div>
                  <div className={`col-3 ${this.state.currentTab === 'tab2' ? 'active-tab' : 'not-active-tab'}`}>
                    <Button
                      variant="secondary"
                      size="medium"
                      state="app"
                      onClick={() => this.onTabButtonClick('tab2')}
                    >{wirelessDataTab}
                    </Button>
                  </div>
                  <div className={`col-3 ${this.state.currentTab === 'tab3' ? 'active-tab' : 'not-active-tab'}`}>
                    <Button
                      variant="secondary"
                      size="medium"
                      state="app"
                      onClick={() => this.onTabButtonClick('tab3')}
                    >{unaddressableDataTab}
                    </Button>
                  </div>
                  <div className={`col-2 ${this.state.currentTab === 'tab4' ? 'active-tab' : 'not-active-tab'}`}>
                    <Button
                      variant="secondary"
                      size="medium"
                      state="app"
                      onClick={() => this.onTabButtonClick('tab4')}
                    >{deviceDataTab}
                    </Button>
                  </div>
                  <div className={`col-1 ${this.state.currentTab === 'tab5' ? 'active-tab' : 'not-active-tab'}`}>
                    <Button
                      variant="secondary"
                      size="medium"
                      state="app"
                      onClick={() => this.onTabButtonClick('tab5')}
                    >{addOnTab}
                    </Button>
                  </div>
                </div>
                {this.state.currentTab === 'tab1' &&
                  <PlanDetailsTable
                    authorableContent={tradeInOffer}
                    getTotalCostAndData={this.getTotalCostAndData}
                    onChangeCheckBox={this.onChangeCheckBox}
                    currentPage={this.state.planDetailsCurrentPage}
                    planDropDownValue={this.state.planDropDownValue}
                    planServiceCheckboxVal={this.state.planServiceCheckboxVal}
                    planServiceCheckAll={this.state.planServiceCheckAll}
                    serviceNumbersPlanDetails={planSearchResults}
                    pageChangeHandler={this.onPlanDetailsPageChangeHandler}
                    searchPlanSelectedOption={this.state.searchPlanSelectedOption}
                    onSearchPlanFieldChange={this.onSearchPlanFieldChange}
                    searchTextChange={this.onPlanSearchTextChange}
                    searchText={this.state.planSearchText}
                    planDropDownOptions={this.state.planDropDownOptions}
                    movePlanDetails={this.movePlanDetails}
                    isBulkPlanModalOpen={this.state.bulkPlanModalOpen}
                    bulkPlanModalOpen={this.onPlanBulkModalOpen}
                    bulkPlanModalClose={this.onPlanBulkModalClose}
                    bulkPlanDeviceValue={this.state.bulkPlanDeviceValue}
                    onBulkPlanChangeDropDown={this.onBulkPlanChangeDropDown}
                    onBulkPlanActionsApply={this.onBulkPlanActionsApply}
                    planSorting={this.state.planSorting}
                    planSortingClick={this.onPlanSortingClick}
                    currentPlanList={currentPlanList}
                    serviceNumbersWithFlag={this.state.serviceNumbersWithFlag}
                    onPlanAllChangeCheckBox={this.onPlanAllChangeCheckBox}
                  />
                }
                {this.state.currentTab === 'tab2' &&
                  <WirelessTable
                    authorableContent={tradeInOffer}
                    onChangeCheckBox={this.onChangeCheckBox}
                    currentPage={this.state.wirelessCurrentPage}
                    wirelessCheckboxVal={this.state.wirelessCheckboxVal}
                    wirelessCheckAll={this.state.wirelessCheckAll}
                    serviceNumbersPlanDetails={wirelessSearchResults}
                    pageChangeHandler={this.onWirelessPageChangeHandler}
                    searchWirelessSelectedOption={this.state.searchWirelessSelectedOption}
                    onSearchWirelessFieldChange={this.onSearchWirelessFieldChange}
                    searchTextChange={this.onWirelessSearchTextChange}
                    searchText={this.state.wirelessSearchText}
                    wirelessDropDownOptions={this.state.wirelessDropDownOptions}
                    isWirelessPlanModalOpen={this.state.bulkWirelessModalOpen}
                    bulkWirelessModalOpen={this.onWirelessBulkModalOpen}
                    bulkWirelessModalClose={this.onWirelessBulkModalClose}
                    sorting={this.state.wirelessSorting}
                    sortingClick={this.onWirelessSortingClick}
                    moveWirelessPlan={this.moveWirelessPlan}
                    bulkWirelessDeviceValue={this.state.bulkWirelessDeviceValue}
                    onBulkWirelessChangeDropDown={this.onBulkWirelessChangeDropDown}
                    bulkActionsApply={this.onBulkWirelessActionsApply}
                    wirelessCheckboxStatus={this.state.wirelessCheckboxStatus}
                    serviceNumbersWithFlag={this.state.serviceNumbersWithFlag}
                    currentPlanList={wirelessCurrentPlanList}
                    currentDevicesList={wirelessCurrentDevicesList}
                    onWirelessAllChangeCheckBox={this.onWirelessAllChangeCheckBox}
                  />
                }
                {this.state.currentTab === 'tab3' &&
                  <UnaddressableTable
                    authorableContent={tradeInOffer}
                    currentPage={this.state.unaddressCurrentPage}
                    serviceNumbersPlanDetails={unaddressSearchResults}
                    serviceNumbersWithFlag={this.state.serviceNumbersWithFlag}
                    pageChangeHandler={this.onUnaddressPageChangeHandler}
                    searchUnaddressSelectedOption={this.state.searchUnaddressSelectedOption}
                    onSearchUnaddressFieldChange={this.onSearchUnaddressFieldChange}
                    sorting={this.state.unaddressSorting}
                    sortingClick={this.onUnaddressSortingClick}
                    searchTextChange={this.onUnaddressSearchTextChange}
                    searchText={this.state.unaddressSearchText}
                    currentPlanList={unaddressCurrentPlanList}
                    currentDevicesList={unaddressCurrentDevicesList}
                    unaddressTreatmentList={unaddressTreatmentList}
                  />
                }
                {this.state.currentTab === 'tab4' &&
                  <TradeInOffer
                    authorableContent={tradeInOffer}
                    serviceNumberArray={searchResults}
                    serviceNumbersWithFlag={this.state.serviceNumbersWithFlag}
                    onChangeCheckBox={this.onChangeCheckBox}
                    tradeInDeviceCheckbox={this.state.tradeInDevice}
                    includeIphoneCheckbox={this.state.includeIphone}
                    migrateToEpicPlan={this.migrateToEpicPlan}
                    onChangeDropDown={this.onChangeDropDown}
                    tradeDropDownValue={this.state.tradeDropDownValue}
                    contractTerm={this.state.contractTerm}
                    savingValue={savingCost}
                    serviceCheckboxVal={this.state.serviceCheckboxVal}
                    isBulkModalOpen={this.state.bulkModalOpen}
                    bulkModalOpen={this.onBulkModalOpen}
                    bulkModalClose={this.onBulkModalClose}
                    bulkActionsApply={this.onBulkActionsApply}
                    bulkNewDeviceValue={this.state.bulkNewDeviceValue}
                    onBulkTradeInCheckBox={this.onBulkTradeInCheckBox}
                    bulkTradeInChecked={this.state.bulkTradeInChecked}
                    onBulkChangeDropDown={this.onBulkChangeDropDown}
                    serviceCheckAll={this.state.serviceCheckAll}
                    currentPage={this.state.currentPage}
                    pageChangeHandler={this.onPageChangeHandler}
                    tradeInOfferSorting={this.state.tradeInOfferSorting}
                    tradeClickSorting={this.onTradeSortingClick}
                    searchFieldSelectedOption={this.state.searchFieldSelectedOption}
                    onSearchFieldChange={this.onSearchFieldChange}
                    searchTextChange={this.onSearchTextChange}
                    searchText={this.state.tradeInSearchText}
                    onChangeContractValue={this.onChangeContractValue}
                    bulkTradePlanDropDownSelection={this.state.bulkTradePlanDropDownSelection}
                    onBulkTradePlanChangeDropDown={this.onBulkTradePlanChangeDropDown}
                    fullVoiceData={filterServiceNumberArr}
                    currentDevicesList={currentDeviceList}
                    updatedSummaryTable={this.state.updatedSummaryTable}
                    onUpdatedSummaryTableValue={this.onUpdatedSummaryTableValue}
                    onServiceAllChangeCheckBox={this.onServiceAllChangeCheckBox}
                    mobileEtcDropDownValue={this.state.mobileEtcDropDownValue}
                    onChangeETCDropdown={this.onChangeETCDropdown}
                    onChangeETCHeaderDropdown={this.onChangeETCHeaderDropdown}
                    headerMobileETCValue={this.state.headerMobileETCValue}
                  />
                }
                {this.state.currentTab === 'tab5' &&
                  <AddOnTable
                    authorableContent={tradeInOffer}
                    onChangeCheckBox={this.onChangeCheckBox}
                    currentPage={this.state.addOnDetailsCurrentPage}
                    addOnCheckboxVal={this.state.addOnCheckboxVal}
                    addOnCheckAll={this.state.addOnCheckAll}
                    serviceNumbersPlanDetails={addOnSearchResults}
                    pageChangeHandler={this.onAddOnDetailsPageChangeHandler}
                    moveAddOnDetails={this.onAddOnChangeDropdown}
                    currentPlanList={currentPlanList}
                    serviceNumbersWithFlag={this.state.serviceNumbersWithFlag}
                    iDOPlanDropDownValue={this.state.iDOPlanDropDownValue}
                    dataTopUpDropDownValue={this.state.dataTopUpDropDownValue}
                    onAddOnChangeCheckBox={this.onAddOnChangeCheckBox}
                    voice2TextCheckboxVal={this.state.voice2TextCheckboxVal}
                    iPhoneMsgBankCheckboxVal={this.state.iPhoneMsgBankCheckboxVal}
                    oneNumberCheckboxVal={this.state.oneNumberCheckboxVal}
                    monthPassCheckboxVal={this.state.monthPassCheckboxVal}
                    acceleratorCheckboxVal={this.state.acceleratorCheckboxVal}
                    demandDataCheckboxVal={this.state.demandDataCheckboxVal}
                    getPlanNameDetails={this.onGetPlanNameDetails}
                    onSearchAddOnFieldChange={this.onSearchAddOnFieldChange}
                    searchAddOnSelectedOption={this.state.searchAddOnSelectedOption}
                    searchTextChange={this.onAddOnSearchTextChange}
                    searchText={this.state.addOnSearchText}
                    updatedSummaryTable={this.state.updatedSummaryTable}
                    onUpdatedSummaryTableValue={this.onUpdatedSummaryTableValue}
                    addonWarningPopup={this.state.addonWarningPopup}
                    addonBulkModal={this.state.addonBulkModal}
                    bulkAddonIDDValue={this.state.bulkAddonIDDValue}
                    bulkAddonDataTopupValue={this.state.bulkAddonDataTopupValue}
                    bulkAddonMobileValue={this.state.bulkAddonMobileValue}
                    bulkAddonVoice2TextCheckbox={this.state.bulkAddonVoice2TextCheckbox}
                    bulkAddonMsgBankCheckbox={this.state.bulkAddonMsgBankCheckbox}
                    bulkAddonOneNumberCheckbox={this.state.bulkAddonOneNumberCheckbox}
                    bulkAddonMonthPassCheckbox={this.state.bulkAddonMonthPassCheckbox}
                    bulkAddonAcceleratorCheckbox={this.state.bulkAddonAcceleratorCheckbox}
                    bulkAddonDemandDataCheckbox={this.state.bulkAddonDemandDataCheckbox}
                    onAddonBulkIDDChangeDropDown={this.onAddonBulkIDDChangeDropDown}
                    onAddonBulkDataTopupChangeDropDown={this.onAddonBulkDataTopupChangeDropDown}
                    onAddonBulkMobileChangeDropDown={this.onAddonBulkMobileChangeDropDown}
                    onAddonBulkCheckBox={this.onAddonBulkCheckBox}
                    onAddOnAllChangeCheckBox={this.onAddOnAllChangeCheckBox}
                    onAddonBulkModalClose={this.onAddonBulkModalClose}
                    onAddonBulkAction={this.onAddonBulkAction}
                    onAddonBulkActionApply={this.onAddonBulkActionApply}
                    onAddonWarningPopupClose={this.onAddonWarningPopupClose}
                    isVoicePlan={this.state.isVoicePlan}
                    isBrodbandPlan={this.state.isBrodbandPlan}
                    isWirelessPlan={this.state.isWirelessPlan}
                  />
                }
                <TotalTradeSection
                  authorableContent={tradeInOffer}
                  totalTradeInValue={totalTradeInValue}
                  fundContributionValue={fundContributionValue}
                  currentFundValue={currentFundValue}
                  addonCosts={addonCosts}
                />
                <DeviceLeasingSection
                  authorableContent={tradeInOffer}
                  motifValue={motifValue}
                  averageAfsValue={averageAfsValue}
                  totalAMPlanDevices={totalAMPlanDevices}
                  moorUpServiceValue={moorUpPerServiceValue}
                  avgPhoneCost={avgPhoneCost}
                  tradeInDeviceCount={tradeInDeviceCount}
                  newDeviceCount={newDeviceCount}
                  rrpCostValue={rrpCost}
                  currentMontlyCost={this.props.getData.totalCurrentSpentPerMonth}
                  newMontlyCost={this.state.totalFutureSpentPerMonth}
                  contractTerm={this.state.contractTerm}
                />
                <SubmitSection
                  authorableContent={explanationSection}
                  onSubmitSiteConfirmButton={this.onSubmitSiteSubmitButton}
                  submitLoader={this.props.submissionInProgress}
                  digitalReady={digitalReadiness && digitalReadiness.trim().length > 0}
                  digitalReadyPreText={digitalReadyPreText}
                  digitalReadyBlankText={digitalReadyBlankText}
                />
                {this.props.formSubmitted &&
                  <GenericAlert
                    name="confirm-banner-primary"
                    header={confirmHeading}
                    description={renderHTML(stripStartingAndEndingPTags(confirmDescription))}
                  />
                }
              </React.Fragment>
            }
          </div>
        </AppWrapper>
      );
    }
    return <Loader />;
  }
}


export default AMCHomePageView;
